import { appConfig } from "./appConfig";

export default [
    {
    "id": 2,
    "imgUrl": `${appConfig.staticDomain}/file/Павильон «Центральный».jpg`,
    "name": "Павильон №75. ЭКСПО",
    "name_eng": "Pavilion №75.Expo",
    "description": "Павильон площадью более 50 тыс. кв. м является самой большой выставочной площадкой на ВДНХ. ",
    "description_eng": "Pavilion with an area of more than 50 thousand square meters.m is the largest exhibition site at VDNH.",
    "mapIcon": "/mapElements/Expo.png",
    "class": "element5",
    "elementInfoClass": "element-info-5",
    "entranceTeleportId": 2
  },
  {
    "id": 10,
    "imgUrl": `${appConfig.staticDomain}/file/Павильон «Центральный».jpg`,
    "name": "Павильон «Первые в России - стране возможностей»",
    "name_eng": "Pavilion «Russia - Country of Opportunities»",
    "description": "В стенах павильона № 1 в рамках Международной выставки-форума \"Россия\" создано уникальное интерактивное пространство — восемь залов посвящены достижениям России через отражение прошлого, настоящего и будущего. Гости смогут увидеть красоту самого павильона, оценить современные технологии и оригинальное шоу, интегрированные в него.",
    "description_eng": "Within the walls of the Pavilion No. 1, within the framework of the international exhibition-forum \"Russia\", a unique interactive space has been created-eight halls are devoted to the achievements of Russia through the reflection of the past, present and future.Guests will be able to see the beauty of the pavilion itself, evaluate modern technologies and the original show integrated into it.",
    "mapIcon": "/mapElements/central.webp",
    "class": "element1",
    "elementInfoClass": "element-info-1",
    "entranceTeleportId": 102
  },
  {
    "id": 29,
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №34. Центр «Космонавтика и авиация».jpg`,
    "name": "Павильон №34. Центр \"Космонавтика и авиация\"",
    "name_eng": "Pavilion №34. Centre \"Kosmonavtika i aviaciya\"",
    "description": "В центре \"Космонавтика и авиация\" можно увидеть более 120 уникальных образцов летательной и космической техники, экспонаты оборонно-промышленных предприятий, свыше 2 тысяч редких архивных документов, фотографий и видеоматериалов об истории космических достижений. Также в павильоне работает сувенирный магазин ВДНХ. В отреставрированном павильоне \"Космос\" работает музейный комплекс мирового уровня — центр \"Космонавтика и авиация\". Огромное выставочное пространство, посвященное отечественной истории освоения космоса, стало важнейшим этапом возрождения Выставки. Павильон построен в 1939 году. Архитекторы — И. Г. Таранов, В. С. Андреев, Н. А. Быкова. Скульптуры и барельефы — С. Д. Меркуров (1881–1952). Реконструирован в 1954 году по проекту архитекторов В. С. Андреева, И. Г. Таранова. Главный конструктор — М. М. Лимановский, конструктор купола — Г. Б. Гордон. В результате реконструкции единое здание павильона имело двойной номер — №32–34. До 1954 года — \"Механизация\". В 1954–1956 годах — \"Механизация и электрификация сельского хозяйства СССР\". В 1956–1966 годах — \"Машиностроение\". Объект культурного наследия федерального значения.",
    "description_eng": "The \"Kosmonavtika i aviaciya\" centre displays over 120 unique samples of aircraft and space equipment, exhibits of defence and industrial enterprises, over 2 thousand rare archive documents, photos and videos about the history of space achievements. The pavilion also houses the VDNH souvenir shop. The restored \"Cosmos\" pavilion houses a world-class museum complex - the \"Kosmonavtika i aviaciya\" centre. The huge exhibition space dedicated to the national history of space exploration became the most important stage of the Exhibition's revival. The pavilion was built in 1939. The architects were I. G. Taranov, V. S. Andreev and N. A. Bykova. Sculptures and bas-reliefs by S. D. Merkurov (1881-1952). Reconstructed in 1954 according to the project of architects V. S. Andreev, I. G. Taranov. The chief designer was M. M. Limanovsky, the dome designer was G. B. Gordon. As a result of the reconstruction, the single pavilion building had a double number - №32-34. Until 1954 - \"Mehanizaciya\". In 1954-1956 - \"Mehanizaciya i elektrifikaciya selskogo hozaystva SSSR\". In 1956-1966 - \"Mashinostroenie\". An object of cultural heritage of federal significance.",
    "mapIcon": "/mapElements/cosmos-pavilion.webp",
    "class": "element2",
    "elementInfoClass": "element-info-2",
    "entranceTeleportId": 100

  },
  {
    "id": 52,
    "imgUrl": `${appConfig.staticDomain}/file/Зелёный театр.jpeg`,
    "name": "Зелёный театр",
    "name_eng": "Green theatre",
    "description": "Зеленый театр ВДНХ — легендарная площадка, место притяжения меломанов и театралов. Здесь, на сцене под открытым небом, представлен разнообразный репертуар: от симфонических концертов и балета до выступлений современных рок-музыкантов. Зеленый театр появился на ВДНХ в 1939 году. В 1954 году театр был реконструирован по проекту московского архитектора Бориса Ефимовича. С самого начала своей истории он неизбежно должен был стать одной из самых легендарных площадок столицы, по праву являясь излюбленным местом выступлений известных коллективов и артистов оперной сцены и советской эстрады. Объект культурного наследия федерального значения.",
    "description_eng": "The Green Theatre of VDNH is a legendary venue, a place of attraction for music lovers and theatregoers. Here, on the open-air stage, a diverse repertoire is presented: from symphony concerts and ballet to performances by modern rock musicians. The Green Theatre appeared at VDNH in 1939. In 1954 the theatre was reconstructed according to the project of Moscow architect Boris Efimovich. From the very beginning of its history it was inevitably to become one of the most legendary venues of the capital, rightfully being a favourite place for performances of famous groups and artists of the opera stage and Soviet variety. An object of cultural heritage of federal significance.",
    "mapIcon": "/mapElements/green-theater.webp",
    "class": "element3",
    "elementInfoClass": "element-info-3"
  },
  {
    "id": 6,
    "imgUrl": `${appConfig.staticDomain}/file/Главный вход.jpeg`,
    "name": "Арка главного входа с прилегающей территорией",
    "name_eng": "Arch of the main entrance with adjacent area",
    "description": "Самая мощная ассоциация с ВДНХ у любого человека — это арка парадного входа на Выставку, открывающая Центральную аллею. На вершине арки \"Тракторист и колхозница\" возносят на 32-метровую высоту аллегорический сноп колосьев — тяжелую промышленность и сельское хозяйство. Арка была построена к открытию ВСХВ в 1954 году, архитектор — Иннокентий Мельчаков, который принимал участие в оформлении советского павильона на Всемирной выставке в Нью-Йорке в 1939 году. Над скульптурой \"Тракторист и колхозница\" — эмблемой Выставки — трудился целый творческий коллектив: А. П. Антропов, С. Д. Рабинович, И. Л. Слоним, Н. Л. Штамм под руководством С. М. Орлова. Объект культурного наследия федерального значения.",
    "description_eng": "The most powerful association with VDNH for any person is the arch of the front entrance to the Exhibition, opening the Central alley. At the top of the arch, the \"Traktorist i kolhoznica\" hoists an allegorical sheaf of ears - heavy industry and agriculture - to a 32-metre height. The arch was built for the opening of the All-Union Agricultural Exhibition in 1954. The architect was Innokenty Melchakov, who took part in the design of the Soviet pavilion at the World Exhibition in New York in 1939. The sculpture \"Traktorist i kolhoznica\" - the emblem of the Exhibition - was worked on by a whole creative team: A. P. Antropov, S. D. Rabinovich, I. L. Slonim, N. L. Stamm under the direction of S. M. Orlov. An object of cultural heritage of federal significance.",
    "mapIcon": "/mapElements/main-enter.webp",
    "class": "element4",
    "elementInfoClass": "element-info-4"
  },
  {
    "name": "Четырнадцать фонтанов Центральной аллеи",
    "name_eng": "Fourteen fountains of the Central alley",
    "description": "Между аркой Главного входа ВДНХ и павильоном №1 \"Центральный\" расположены 14 фонтанов (по 7 с каждой стороны). Каждый фонтан находится в отдельной чаше, облицованной красным полированным гранитом. Чаши выполнены в форме правильного восьмигранника. Фонтан имеет 12 вертикальных и 12 радиальных, расходящихся веером от центральной части, струй. Летом 2018 года 14 фонтанов открылись после реставрации. Все работы проводились в строгом соответствии с проектом 1954 года. Возведены к открытию ВСХВ в 1954 году. Архитекторы Ю. В. Щуко, В. М. Куранов.  Объект культурного наследия федерального значения.",
    "description_eng": "There are 14 fountains (7 on each side) between the arch of the Main entrance of VDNH and Pavilion №1 \"Centralny\". Each fountain is located in a separate bowl lined with red polished granite. The bowls are made in the form of a regular octahedron. The fountain has 12 vertical and 12 radial jets fanning out from the central part. In the summer of 2018, 14 fountains opened after restoration. All works were carried out in strict accordance with the project of 1954. They were erected for the opening of the All-Union Agricultural Exhibition in 1954. Architects Y. V. Shchuko, V. M. Kuranov. An object of cultural heritage of federal significance.",
    "category": "Фонтаны",
    "width": "",
    "height": "",
    "left": "",
    "top": "",
    "borderRadius": "100",
    "transform": "",
    "media": {
      "width": "",
      "height": "",
      "left": "",
      "top": "",
      "borderRadius": "100",
      "transform": ""
    },
    "hidden": true,
    "imgUrl": `${appConfig.staticDomain}/file/14 фонтанов центральной аллеи.jpeg`,
    "id": 1,
    "cantTeleportation": true
  },
  {
    "name": "Фонтан \"Дружба народов\"",
    "name_eng": "Fountain \"Druzhba narodov\"",
    "description": "Фонтан \"Дружба народов\" — один из символов не только ВДНХ, но и Москвы. Его композиция состоит из нескольких частей. Овальная чаша фонтана увенчана золотым снопом пшеницы, технической конопли и подсолнухов. Вокруг снопа стоят позолоченные статуи девушек, символизирующих советские республики: их количество равно шестнадцати — по числу административно-территориальных единиц, входивших в СССР на момент создания объекта культурного наследия. Девушки держат в руках сельскохозяйственное растение, которое чаще всего выращивалось на полях их республик. Фонтан представляет собой сложную систему из 784 струй, высота которых достигает 20 метров. Площадь бассейна фонтана составляет 3,8 тысячи квадратных метров. Создан в 1954 году. Архитектор — К. Т. Топуридзе, инженер — В. И. Клявина, скульпторы — З. В. Баженова, А. И. Тенета, И. М. Чайков, З. В. Рылеева, В. П. Гаврилов. Объект культурного наследия федерального значения.",
    "description_eng": "The \"Druzhba narodov\" Fountain is one of the symbols not only of VDNH, but also of Moscow. Its composition consists of several parts. The oval bowl of the fountain is topped with a golden sheaf of wheat, industrial hemp and sunflowers. Around the sheaf are gilded statues of girls symbolising the Soviet republics: their number is equal to sixteen - according to the number of administrative-territorial units that were part of the USSR at the time of the creation of the cultural heritage site. The girls hold in their hands an agricultural plant, which was most often grown in the fields of their republics. The fountain is a complex system of 784 jets, the height of which reaches 20 metres. The area of the fountain's basin is 3.8 thousand square metres. It was created in 1954. Architect - K. T. Topuridze, engineer - V. I. Klyavina, sculptors - Z. V. Bazhenova, A. I. Teneta, I. M. Chaikov, Z. V. Ryleeva, V. P. Gavrilov. An object of cultural heritage of federal significance.",
    "category": "Фонтаны",
    "width": "9.3",
    "height": "5.5",
    "left": "68",
    "top": "34.8",
    "borderRadius": "100",
    "transform": "",
    "marginTop": "-3",
    "marginBot": "0",
    "marginLeft": "0",
    "marginRight": "0",
    "transformImage": "0",
    "media": {
      "width": "6.7",
      "height": "4",
      "left": "50.1",
      "top": "25.5",
      "borderRadius": "48",
      "transformImage": "0",
      "marginTop": "-2",
      "marginBot": "0",
      "marginLeft": "0",
      "marginRight": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Фонтан «Дружба народов.jpg`,
    "id": 222
  },
  {
    "name": "Фонтан \"Каменный цветок\"",
    "name_eng": "Fountain \"Kamenny cvetok\"",
    "description": "Фонтан \"Kamenny cvetok\" — один из четырех знаменитых исторических фонтанов ВДНХ. Навеянный яркими образами уральских сказок П. Бажова, фонтан изобилует пышными скульптурными деталями. Центр композиции — чаша в виде цветка, распускающегося среди самоцветов. На гранитных постаментах, украшенных чугунными волютами, установлены 16 бронзовых композиций-натюрмортов с дарами природы союзных республик. Создан в 1954 году. Архитектор — К. Т. Топуридзе, скульптор — П. И. Добрынин. Объект культурного наследия федерального значения.",
    "description_eng": "The \"Stone Flower\" Fountain is one of the four famous historical fountains of VDNH. Inspired by the vivid images of Ural fairytales by P. Bazhov, the fountain is full of lush sculptural details. The centre of the composition is a bowl in the form of a flower blossoming among semi-precious stones. On granite pedestals decorated with cast-iron volutes, 16 bronze still-life compositions with gifts of nature of the Union republics are installed. It was created in 1954. Architect - K.T. Topuridze, sculptor - P.I. Dobrynin. An object of cultural heritage of federal significance.",
    "category": "Фонтаны",
    "width": "",
    "height": "",
    "left": "",
    "top": "",
    "borderRadius": "100",
    "transform": "",
    "media": {
      "width": "",
      "height": "",
      "left": "",
      "top": "",
      "borderRadius": "100",
      "transform": ""
    },
    "hidden": true,
    "imgUrl": `${appConfig.staticDomain}/file/Фонтан «Каменный цветок».jpeg`,
    "id": 333
  },
  {
    "name": "Фонтан \"Мальчик с рыбой\"",
    "name_eng": "Fountain \"Malchik s ryboj\"",
    "description": "У этого небольшого бассейна-фонтана со скульптурой Бориса Николаевича Сона целых два имени: \"Рыбак\" и \"Мальчик с рыбой\". Фонтан расположен позади павильона №64. Данная скульптура 1954 года — полный аналог оригинала 1949 года, установленного в парке Победы в Санкт-Петербурге.",
    "description_eng": "This small pool-fountain with a sculpture by Boris Nikolayevich Son has two names: \"Rybak\" and \"Malchik s ryboj\". The fountain is located behind Pavilion №64. This sculpture (1954) is a full analogue of the original sculpture (1949) installed in Victory Park in St. Petersburg.",
    "category": "Фонтаны",
    "width": "",
    "height": "",
    "left": "",
    "top": "",
    "borderRadius": "100",
    "transform": "",
    "media": {
      "width": "",
      "height": "",
      "left": "",
      "top": "",
      "borderRadius": "100",
      "transform": ""
    },
    "hidden": true,
    "imgUrl": `${appConfig.staticDomain}/file/Фонтан «Мальчик с рыбой».jpg`,
    "id": 555
  },
  {
    "name": "Арка главного входа с прилегающей территорией",
    "name_eng": "Arch of the main entrance with adjacent area",
    "description": "Самая мощная ассоциация с ВДНХ у любого человека — это арка парадного входа на Выставку, открывающая Центральную аллею. На вершине арки \"Тракторист и колхозница\" возносят на 32-метровую высоту аллегорический сноп колосьев — тяжелую промышленность и сельское хозяйство. Арка была построена к открытию ВСХВ в 1954 году, архитектор — Иннокентий Мельчаков, который принимал участие в оформлении советского павильона на Всемирной выставке в Нью-Йорке в 1939 году. Над скульптурой \"Тракторист и колхозница\" — эмблемой Выставки — трудился целый творческий коллектив: А. П. Антропов, С. Д. Рабинович, И. Л. Слоним, Н. Л. Штамм под руководством С. М. Орлова. Объект культурного наследия федерального значения.",
    "description_eng": "The most powerful association with VDNH for any person is the arch of the front entrance to the Exhibition, opening the Central alley. At the top of the arch, the \"Traktorist i kolhoznica\" hoists an allegorical sheaf of ears - heavy industry and agriculture - to a 32-metre height. The arch was built for the opening of the All-Union Agricultural Exhibition in 1954. The architect was Innokenty Melchakov, who took part in the design of the Soviet pavilion at the World Exhibition in New York in 1939. The sculpture \"Traktorist i kolhoznica\" - the emblem of the Exhibition - was worked on by a whole creative team: A. P. Antropov, S. D. Rabinovich, I. L. Slonim, N. L. Stamm under the direction of S. M. Orlov. An object of cultural heritage of federal significance.",
    "category": "Входы",
    "width": "",
    "height": "",
    "left": "",
    "top": "",
    "borderRadius": "100",
    "transform": "",
    "media": {
      "width": "",
      "height": "",
      "left": "",
      "top": "",
      "borderRadius": "100",
      "transform": ""
    },
    "hidden": true,
    "imgUrl": `${appConfig.staticDomain}/file/Главный вход.jpeg`,
    "id": 6
  },
  {
    "name": "Павильон №1",
    "name_eng": "Pavilion №1",
    "description": "Павильон №1 \"Центральный\" — одно из самых главных и наиболее монументальных сооружений Выставки. Архитектура павильона отсылает к лучшим примерам русской классической архитектуры. Его уступчатая высотная композиция завершена шпилем со звездой, а трехъярусная композиция, торжественность и стиль навевают образы памятников русского ампира, более всего перекликаясь с силуэтом башни петербургского Адмиралтейства. Особое место в оформлении высотной композиции играют скульптуры, расположенные по четырем сторонам света. Экспозиция павильона отображала основные вехи в истории советского государства и успехи в индустриализации, сельском хозяйстве, науке и культуре. Для удобного расположения и осмотра была избрана планировка, представляющая собой центральный зал и связанные с ним восемь выставочных. Все девять залов павильона были отделаны искусственным мрамором, украшены скульптурой и живописью, выполненной выдающимися советскими мастерами искусства: А. М. Герасимовым, А. А. Дейнекой, П. П. Соколовым-Скалей, М. Г. Манизером, Е. В. Вучетичем и др. Особенно впечатляла анфилада залов, посвященных Октябрьской революции, Конституции, борьбе СССР за мир. Их отделка сохранилась почти в первозданном виде. Первый зал Октябрьской революции украшали два больших монументальных панно \"Штурм Зимнего дворца в октябре 1917 года\" и \"Провозглашение В. И. Лениным советской власти на Втором Всероссийском съезде Советов\" кисти П. П. Соколова-Скали. Далее, проходя через большой портал в виде триумфальной арки, посетители попадали в великолепный зал Советской Конституции высотой 30 м, расположенный под башней павильона. Общая высота павильона вместе со шпилем достигает 97 метров, а общая площадь — 9 378,2 кв. м. Павильон построен в 1954 г., архитекторы — Ю. В. Щуко и Е. А. Столяров. До 1963 г. — \"Главный\" павильон. Объект культурного наследия федерального значения.",
    "description_eng": "Pavilion №1 \"Centralny\" is one of the most important and monumental buildings of the Exhibition. The pavilion's architecture refers to the best examples of Russian classical architecture. Its stepped high-rise composition is crowned by a spire with a star, while its three-tiered composition, solemnity and style evoke images of Russian Empire monuments, most of all echoing the silhouette of the tower of the St. Petersburg Admiralty. A special place in the design of the high-rise composition is played by sculptures located on the four sides of the world. The exposition of the pavilion depicted the main milestones in the history of the Soviet state and successes in industrialisation, agriculture, science and culture. The layout of the pavilion was chosen for its convenient location and viewing, which consisted of a central hall and eight exhibition halls connected to it. All nine halls of the pavilion were finished with artificial marble, decorated with sculptures and paintings made by outstanding Soviet masters of art: A. M. Gerasimov, A. A. Deineka, P. P. Sokolov-Skaley, M. G. Manizer, E. V. Vuchetich and others. Particularly impressive was the enfilade of halls dedicated to the October Revolution, the Constitution and the USSR's struggle for peace. Their decoration has been preserved almost in pristine condition.\nThe first Hall of the October Revolution was decorated with two large monumental panels \"Shturm Zimnego dvorca v oktjabre 1917 goda\" and \"Provozglashenie V. I. Leninym sovetskoj vlasti na Vtorom Vserossijskom syezde Sovetov\" by P. P. Sokolov-Skali. Then, passing through a large portal in the form of a triumphal arch, visitors entered the magnificent 30-metre-high hall of the Soviet Constitution, located under the pavilion's tower. The total height of the pavilion together with the spire reaches 97 metres and the total area is 9,378.2 square metres. The pavilion was built in 1954, architects - Y. V. Shchuko and E. A. Stolyarov. Until 1963 it was the \"Glavny\" pavilion. An object of cultural heritage of federal significance.",
    "category": "Павильоны и сооружения",
    "width": "",
    "height": "",
    "left": "",
    "top": "",
    "borderRadius": "100",
    "transform": "",
    "media": {
      "width": "",
      "height": "",
      "left": "",
      "top": "",
      "borderRadius": "100",
      "transform": ""
    },
    "hidden": true,
    "imgUrl": `${appConfig.staticDomain}/file/Павильон «Центральный».jpg`,
    "id": 10,
    "entranceTeleportId": 102
  },
  {
    "name": "Павильон «СБЕР»",
    "name_eng": "Pavilion «Sber»",
    "description": "В павильоне Сбера на ВДНХ (павильон № 2) представлена масштабная экспозиция, посвящённая истории банка и последним достижениям в области технологий, цифровизации и искусственного интеллекта (AI). ",
    "description_eng": "In the Sberban pavilion at VDNH (Pavilion No. 2), a large -scale exposition is presented, dedicated to the history of the bank and the latest achievements in the field of technology, digitalization and artificial intelligence (AI).",
    "category": "Павильоны и сооружения",
    "mapIcon": "/mapElements/sber.png",
    "class": "element9",
    "elementInfoClass": "element-info-9",
    "imgUrl": `${appConfig.staticDomain}/file/Павильон Робостанция.jpg`,
    "id": 11
  },
  {
    "name": "Павильон №4. Выставочно-торговый центр Кыргызской Республики",
    "name_eng": "Pavilion №4. Exhibition and Trade Centre of the Kyrgyz Republic",
    "description": "Первоначально павильон предназначался для демонстрации достижений Эстонской Республики в промышленности, сельском хозяйстве и культуре. Сейчас закрыт на реставрацию. После завершения работ в здании будет работать торгово-выставочный центр Кыргызской Республики. Павильон построен в 1954 году, архитекторы — Х. А. Арман, А. Х. Вольберг, Н. К. Тарвас. До 1964 года — павильон \"Эстонская ССР\". Объект культурного наследия федерального значения.",
    "description_eng": "The pavilion was originally intended to demonstrate the achievements of the Republic of Estonia in industry, agriculture and culture. Now it is closed for restoration. After the work is completed, the building will house the Trade and Exhibition Centre of the Kyrgyz Republic. The pavilion was built in 1954, architects - H. A. Arman, A. H. Volberg, N. K. Tarvas. Until 1964 - the pavilion \"Estonskaya SSR\". An object of cultural heritage of federal significance.",
    "category": "Павильоны и сооружения",
    "width": "3.5",
    "height": "2.3",
    "left": "65.8",
    "top": "42.7",
    "borderRadius": "33",
    "transform": "-36",
    "transformImage": "36",
    "marginTop": "-1",
    "marginBot": "0",
    "marginLeft": "0",
    "marginRight": "-1",
    "media": {
      "width": "2.6",
      "height": "1.6",
      "left": "48.5",
      "top": "31.5",
      "borderRadius": "12",
      "transform": "-12",
      "transformImage": "12",
      "marginTop": "-2",
      "marginBot": "0",
      "marginLeft": "0",
      "marginRight": "-0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №4. Выставочно-торговый центр Киргизской Республики.jpg`,
    "id": 12
  },
  {
    "name": "Павильон №5. Музей городского хозяйства Москвы",
    "name_eng": "Pavilion №5. Moscow urban economy museum",
    "description": "В 2022 году в павильоне №5 \"Физика\" открылся Музей городского хозяйства Москвы. Интерактивная экспозиция в простой и увлекательной форме рассказывает, как создается и поддерживается комфортная среда для проживания в мегаполисе. Экспозиция включает три основных раздела. В первом из них — \"Управление\" — представлен прототип автоматизированной системы управления объединенными диспетчерскими службами Москвы. На 30-метровом экране посетители в реальном времени могут наблюдать за всем происходящим в городе. Например, изучать актуальную информацию по суточному потреблению газа, воды и теплоэнергии, оценивать ход капитального ремонта. Также здесь можно узнать о всей структуре организаций, входящих в Комплекс городского хозяйства столицы. Второй раздел — \"Квартира\" — рассказывает, из чего состоит ежедневная работа по поддержанию функционирования множества привычных для горожан удобств. Его центральным экспонатом стала квартира, от которой расходятся все коммуникации. Посетители могут увидеть, какой путь проходит вода, прежде чем оказаться в кухонном кране, как работают лифты, системы водоотведения и канализации, сбора и утилизации отходов, эксплуатации и ремонта, коммунальных платежей, газовое и дорожное хозяйство, теплоснабжение, газоснабжение и электроснабжение. В третьем разделе — \"Город\" — посетители узнают, как в целом функционирует городское хозяйство, какие механизмы и службы ежедневно создают и поддерживают комфортную среду в мегаполисе. Здесь разместили 13-метровый макет Москвы. На его верхнем уровне находятся здания, набережные, парки, мосты и эстакады, на нижнем — подземные коммуникации, коллекторы и тоннели. Подробно рассмотреть и изучить все объекты макета гости могут с помощью биноскопов (смотровых биноклей) и дополненной реальности. Павильон занимает центральное место в композиции сквера Прибалтийских республик, созданного при послевоенной реконструкции выставки, когда для каждой из республик Прибалтики были созданы отдельные павильоны взамен единого, существовавшего до войны. Главный фасад здания обрамлен портиком с 12 колоннами, которые сгруппированы парами. Первоначально окна главного фасада были заполнены витражами с пейзажами латвийских городов и сюжетами на сельскохозяйственную тематику, до наших дней они, к сожалению, не сохранились. Павильон построен в 1954 году, архитекторы — А. Я. Айварс, В. И. Закис, К. Я. Плуксне. До 1964 года — павильон \"Латвийская ССР\", затем — \"Физика\". Объект культурного наследия федерального значения.",
    "description_eng": "In 2022, the Museum of Moscow urban economy opened in Pavilion №5 \"Fizika\". The interactive exposition tells in a simple and entertaining way how a comfortable environment for living in the megacity is created and maintained. The exposition includes three main sections. The first of them - \"Upravlenie\" - presents a prototype of the automated control system of the united dispatch services of Moscow. On a 30-metre screen visitors can watch everything happening in the city in real time. For example, to study the current information on daily consumption of gas, water and heat energy, to assess the progress of major repairs. Also here you can find out about the whole structure of organisations that are part of the Urban economy Complex of the capital. The second section - \"Kvartira\" - tells what daily work consists of to maintain the functioning of many amenities familiar to the citizens. Its central exhibit is a flat, from which all communications flow. Visitors can see how water travels before it reaches the kitchen tap, how lifts work, water and sewage systems, waste collection and disposal, operation and repair, utility payments, gas and road maintenance, heat, gas and electricity supply. In the third section - \"Gorod\" - visitors will learn how the city economy functions as a whole, what mechanisms and services create and maintain a comfortable environment in the metropolis on a daily basis. A 13-metre model of Moscow has been placed here. On its upper level there are buildings, embankments, parks, bridges and overpasses, on the lower level - underground communications, collectors and tunnels. The guests can examine and study all the objects of the model in detail using binoscopes (viewing binoculars) and augmented reality. The pavilion occupies a central place in the composition of the square of the Baltic republics, created during the post-war reconstruction of the exhibition, when separate pavilions were created for each of the Baltic republics to replace the single pavilion that existed before the war. The main facade of the building is framed by a portico with 12 columns, which are grouped in pairs. The windows of the main facade were originally filled with stained glass windows with landscapes of Latvian cities and agricultural themes, but unfortunately they have not survived to this day. The pavilion was built in 1954 by architects A. J. Aivars, V. I. Zakis and K. J. Plūksne. Until 1964 it was the \"Latviyskaya SSR\" pavilion, then the \"Fizika\" pavilion. An object of cultural heritage of federal significance.",
    "category": "Павильоны и сооружения",
    "width": "4.5",
    "height": "3.3",
    "left": "62",
    "top": "41.4",
    "borderRadius": "42",
    "transform": "-29",
    "transformImage": "29",
    "marginTop": "-1.5",
    "marginRight": "-1.5",
    "marginBot": "0",
    "marginLeft": "0",
    "media": {
      "width": "3.5",
      "height": "2.3",
      "left": "45.6",
      "top": "30.5",
      "borderRadius": "42",
      "transform": "-29",
      "transformImage": "29",
      "marginTop": "-1.5",
      "marginRight": "-1.5",
      "marginBot": "0",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №5. «Музей городского хозяйства Москвы».jpg`,
    "id": 13
  },
  {
    "name": "Павильон №6. Выставочно-торговый центр Республики Абхазия",
    "name_eng": "Pavilion №6. Exhibition and Trade Centre of the Republic of Abkhazia",
    "description": "Во время послевоенной реконструкции Выставки было решено построить отдельные павильоны для всех трёх прибалтийских республик, в том числе и для Литовской ССР, тогда как до войны существовал один посвящённый им павильон. Павильон №6 оформлен в стиле сталинского ампира, в декоре прослеживаются народные литовские мотивы. После завершения реставрационных работ здесь откроется торгово-выставочный центр Республики Абхазия. Павильон построен в 1954 году; архитекторы — А. Я. Кумпис, Ю. А. Лукошайтис, К. К. Шельгис. До 1964 года — \"Литовская ССР\". С 1964 года павильон назывался \"Академия наук СССР — Химия\". Объект культурного наследия федерального значения.",
    "description_eng": "During the post-war reconstruction of the Exhibition, it was decided to build separate pavilions for all three Baltic republics, including the Lithuanian SSR, whereas before the war there was one pavilion dedicated to them. Pavilion №6 is decorated in the Stalinist Empire style, with Lithuanian folk motifs in the décor. After restoration works are completed, the Trade and Exhibition Centre of the Republic of Abkhazia will be opened here. The pavilion was built in 1954; the architects were A. J. Kumpis, J. A. Lukoshaitis and K. K. Shelgis. Until 1964 it was called \"Litovskaya SSR\". Since 1964 the pavilion was called \"Akademiya nauk SSSR — Himiya\". An object of cultural heritage of federal significance.",
    "category": "Павильоны и сооружения",
    "width": "3.6",
    "height": "2.3",
    "left": "61.7",
    "top": "39.4",
    "borderRadius": "42",
    "transform": "-29",
    "transformImage": "29",
    "marginTop": "-1.5",
    "marginRight": "-1.5",
    "marginBot": "0",
    "marginLeft": "0",
    "media": {
      "width": "2.8",
      "height": "1.7",
      "left": "45.4",
      "top": "29.1",
      "borderRadius": "42",
      "transform": "-29",
      "transformImage": "29",
      "marginTop": "-1.5",
      "marginRight": "-1.5",
      "marginBot": "0",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №6. Выставочно-торговый центр Республики Абхазия.jpg`,
    "id": 14
  },
  {
    "name": "Павильон №7 \"Союзмультпарк\"",
    "name_eng": "Pavilion №7 \"Soyuzmultpark\"",
    "description": "Единственный в России мультимедийный центр \"Союзмультпарк\" — уникальная площадка для детей и взрослых, где каждый может погрузиться в мир любимых мультипликационных героев, оживить их, получить новые навыки и раскрыть свои таланты. Гостей ждут 18 интерактивных аттракционов, разработанных с применением цифровых технологий: VR (виртуальной реальности), AR (дополненной реальности), 3D-анимации, автономного развития и бесконечной генерации графических объектов. Также в парке проходят лекции, выставки и мастер-классы по мультипликации. Проект выполнен в институте Гипроторг. Построен в 1978 году. Архитекторы — З. Арзамасова, Т. Петрова. Инженер — Д. Земцев. C 1978 года — павильон \"Семена\".",
    "description_eng": "The only multimedia centre in Russia \"Soyuzmultpark\" is a unique platform for children and adults, where everyone can immerse themselves in the world of their favourite cartoon characters, bring them to life, learn new skills and discover their talents. The guests are welcomed by 18 interactive attractions developed with the use of digital technologies: VR (virtual reality), AR (augmented reality), 3D animation, autonomous development and infinite generation of graphic objects. The park also hosts lectures, exhibitions and masterclasses on animation. The project was made at the Giprotorg Institute. It was built in 1978. Architects - Z. Arzamasova, T. Petrova. Engineer - D. Zemtsev. Since 1978 - \"Semena\" pavilion.",
    "category": "Павильоны и сооружения",
    "width": "4.5",
    "height": "3.2",
    "left": "51.55",
    "top": "44.95",
    "borderRadius": "42",
    "transform": "-23",
    "transformImage": "23",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "1.5",
    "marginLeft": "1",
    "media": {
      "width": "3.3",
      "height": "2.3",
      "left": "38.15",
      "top": "32.95",
      "borderRadius": "42",
      "transform": "-5",
      "transformImage": "5",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "1.5",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №7. «Союзмультпарк».jpg`,
    "id": 15,
    "cantTeleportation": true
  },
  {
    "name": "Павильон №9 \"Театр сказок\"",
    "name_eng": "Pavilion №9 \"Teatr skazok\"",
    "description": "Детский интерактивный \"Театр сказок\" — это уникальное мультимедийное пространство, где каждый зритель может взаимодействовать с персонажем и влиять на сюжет сказки. Волшебное представление завораживает не только маленьких, но и взрослых зрителей. Здесь декорации и реквизит соединяются с 3D-графикой. Любой спектакль в \"Театре сказок\" будет по-своему уникален благодаря возможности варьировать сценарий в зависимости от реакции посетителей. Погружение в сказочную атмосферу начинается сразу при входе в театр. В фойе на лесной опушке \"растут\" веселый гриб-говорун и огромный дуб, которому можно рассказать свое заветное желание. Само представление проходит в уютном зале, напоминающем волшебный лес. Благодаря современным технологиям зрители становятся непосредственными участниками интерактивного представления и могут влиять на сюжет. Шоу рассчитано на детей от трех до десяти лет, но вызовет интерес и у взрослых. Яркие декорации, уникальные мультимедийные технологии, захватывающий сюжет и профессиональные актеры — все это оставит яркие впечатления у гостей всех возрастов. До 2018 года в павильоне располагалась экспозиция \"Юные техники\", где были представлены модели космической, промышленной и сельскохозяйственной техники, кибернетические приборы и электромузыкальные инструменты, счетно-решающие устройства и даже изготовленный одним из начинающих ученых лазер.",
    "description_eng": "Children's interactive \"Teatr skazok\" is a unique multimedia space where every spectator can interact with a character and influence the plot of a fairy tale. The magical performance mesmerises not only small but also adult spectators. Here scenery and props are combined with 3D-graphics. Any performance in the \"Teatr skazok\" will be unique in its own way due to the possibility to vary the scenario depending on the reaction of visitors. Immersion in the fairy-tale atmosphere begins immediately upon entering the theatre. In the foyer on the forest edge \"grow\" a cheerful mushroom and a huge oak tree, to which you can tell your cherished wish. The performance itself takes place in a cosy hall reminiscent of a magical forest. Thanks to modern technologies the spectators become direct participants of the interactive performance and can influence the plot. The show is designed for children from three to ten years old, but it will also be of interest to adults. Bright scenery, unique multimedia technologies, exciting plot and professional actors - all this will leave a vivid impression on guests of all ages. Until 2018, the pavilion housed the \"Junye tehniki\" exposition, where models of space, industrial and agricultural equipment, cybernetic devices and electric musical instruments, counting and solving devices, and even a laser made by one of the budding scientists were presented.",
    "category": "Павильоны и сооружения",
    "width": "2.2",
    "height": "2.8",
    "left": "56.3",
    "top": "39.3",
    "borderRadius": "64",
    "transform": "-65",
    "transformImage": "65",
    "marginTop": "-1",
    "marginRight": "-1",
    "marginBot": "0",
    "marginLeft": "0",
    "media": {
      "width": "1.5",
      "height": "2.2",
      "left": "41.6",
      "top": "28.8",
      "borderRadius": "64",
      "transform": "-65",
      "transformImage": "65",
      "marginTop": "-1",
      "marginRight": "-1",
      "marginBot": "0",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №9. «Театр сказок».jpg`,
    "id": 16
  },
  {
    "name": "Павильон №14. Выставочно-торговый центр Азербайджанской Республики",
    "name_eng": "Pavilion №14. Exhibition and Trade Centre of the Republic of Azerbaijan",
    "description": "Официальная церемония открытия отреставрированного павильона республики Азербайджан прошла 23 ноября 2019 года. В павильоне находится торгово-выставочный центр страны. Деятельность центра направлена на культурное и деловое представительство Азербайджана в России, развитие сотрудничества между странами. В отреставрированном павильоне открыто несколько тематических зон, посвященных российско-азербайджанскому сотрудничеству: постоянно действующая музейная экспозиция, знакомящая посетителей с историей, культурой и развитием Азербайджана, выставочная зона, зал для презентаций, библиотека с читальным залом, торговое представительство и кафе-чайная, расположенная в оранжерее. Павильон построен в 1939 году по проекту архитекторов С. А. Дадашева, М. А. Усейнова. До 1963 года — \"Азербайджанская ССР\". Объект культурного наследия федерального значения.",
    "description_eng": "The official opening ceremony of the renovated pavilion of the Republic of Azerbaijan was held on 23 November 2019. The pavilion houses the country's trade and exhibition centre. The centre's activity is aimed at Azerbaijan's cultural and business representation in Russia and the development of cooperation between the countries. The renovated pavilion has opened several thematic zones dedicated to Russian-Azerbaijani cooperation: a permanent museum exposition introducing visitors to the history, culture and development of Azerbaijan, an exhibition zone, a presentation hall, a library with a reading room, a trade mission and a café-tea house located in a greenhouse. The pavilion was built in 1939 according to the project of architects S. A. Dadashev, M. A. Useynov. Until 1963 - \"Azerbaydzhanskaya SSR\". An object of cultural heritage of federal significance.",
    "category": "Павильоны и сооружения",
    "width": "5.4",
    "height": "3",
    "left": "50",
    "top": "30.5",
    "borderRadius": "44",
    "transform": "-32",
    "transformImage": "32",
    "marginTop": "-1",
    "marginRight": "-1",
    "marginBot": "0",
    "marginLeft": "0",
    "media": {
      "width": "3.9",
      "height": "2.3",
      "left": "37",
      "top": "22.3",
      "borderRadius": "44",
      "transform": "-31",
      "transformImage": "31",
      "marginTop": "-1",
      "marginRight": "-1",
      "marginBot": "0",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №14. Выставочно-торговый центр Азербайджанской Республики.jpg`,
    "id": 17
  },
  {
    "name": "Павильон №17. Галерея \"Лес\"",
    "name_eng": "Pavilion №17. Gallery \"Les\"",
    "description": "Галерея \"Лес\" — это яркое приключение на базе передовых мультимедиа- и интерактивных технологий, 18 оригинальных инсталляций, объединенных общей экспозицией. Галерея открыта в историческом павильоне №17: он был создан в 1954 году и посвящен лесной промышленности. В ходе небольшого интерактивного путешествия гости смогут узнать, что общего между человеком и деревом, как общаются деревья, поиграть в театр теней и лесную викторину, помочь олененку попасть к маме или вызвать лешего. В галерее можно поучаствовать в восстановлении лесов, оплатив высадку саженцев на территории России. Саженцы высаживают партнеры галереи два раза в год: весной и осенью.",
    "description_eng": "The \"Les\" gallery is a colourful adventure based on advanced multimedia and interactive technologies, 18 original installations united by a common exposition. The gallery is open in the historical pavilion № 17: it was created in 1954 and is dedicated to the timber industry. During a small interactive journey, guests will be able to learn what a man and a tree have in common, how trees communicate, play shadow theatre and forest quiz, help a baby deer to get to its mother or summon a forest lion. In the gallery you can take part in reforestation by paying for the planting of saplings in Russia. Seedlings are planted by gallery partners twice a year: in spring and autumn.",
    "category": "Павильоны и сооружения",
    "width": "4",
    "height": "2.7",
    "left": "40.4",
    "top": "29.7",
    "borderRadius": "46",
    "transform": "-28",
    "transformImage": "28",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "2",
    "marginLeft": "0",
    "media": {
      "width": "3",
      "height": "1.7",
      "left": "29.8",
      "top": "22",
      "borderRadius": "46",
      "transform": "-20",
      "transformImage": "20",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "2",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №17. Галерея «Лес».jpg`,
    "id": 19
  },
  {
    "name": "Павильон №18. Выставочно-торговый центр Республики Беларусь",
    "name_eng": "Pavilion №18. Exhibition and Trade Centre of the Republic of Belarus",
    "description": "В павильоне располагается торгово-выставочный центр Республики Беларусь, в котором представлены товары белорусских производителей. Работает интернет-магазин с доставкой, а также кафе белорусской кухни \"Бульбяная\". Павильон построен в 1954 году по проекту Г. А. Захарова, З. С. Чернышева. Выразительную архитектурную композицию здания венчает скульптура \"Родина\" — фигура колхозницы, облицованная золотой смальтой. До 1964 года — павильон \"Белорусская ССР\", в 1964–2008 годах — \"Электротехника\". Объект культурного наследия федерального значения.",
    "description_eng": "The pavilion houses a trade and exhibition centre of the Republic of Belarus, which presents goods of Belarusian manufacturers. There is an online shop with delivery, as well as a café of Belarusian cuisine \"Bulbyanaya\". The pavilion was built in 1954 according to the project of G. A. Zakharov and Z. S. Chernyshev. The expressive architectural composition of the building is crowned by the sculpture \"Rodina\" - a figure of a collective farmer's woman faced with gold smalt. Until 1964 it was the \"Belorusskaya SSR\" pavilion, in 1964-2008 it was the \"Elektrotehnika\" pavilion. An object of cultural heritage of federal significance.",
    "category": "Павильоны и сооружения",
    "width": "4.5",
    "height": "2.7",
    "left": "44.1",
    "top": "26.4",
    "borderRadius": "46",
    "transform": "19",
    "transformImage": "-19",
    "marginTop": "-2",
    "marginRight": "1",
    "marginBot": "0",
    "marginLeft": "0",
    "media": {
      "width": "3.3",
      "height": "2.2",
      "left": "32.5",
      "top": "19.3",
      "borderRadius": "61",
      "transform": "12",
      "transformImage": "-12",
      "marginTop": "-2",
      "marginRight": "1",
      "marginBot": "0",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №18. Выставочно-торговый центр Республики Беларусь.jpg`,
    "id": 20
  },
  {
    "name": "Павильон №20 \"Центральный дом автоспорта\"",
    "name_eng": "Pavilion №20 \"Centralny dom avtosporta\"",
    "description": "До реставрации выставочный павильон знакомил посетителей с достижениями химической отрасли Советского Союза. В 2024 году на базе павильона открывается дом автоспорта SMP Racing. Павильон построен в 1967 году, архитекторы — Б. Виленский, И. Левитес, Н. Булкин, М. Ляховский, З. Назаров при участии А. Вершинина. До 1992 года — \"Химическая промышленность\".",
    "description_eng": "Before restoration, the exhibition pavilion familiarised visitors with the achievements of the Soviet Union's chemical industry. In 2024, the pavilion will be the home of SMP Racing motorsport. The pavilion was built in 1967, architects - B. Vilensky, I. Levites, N. Bulkin, M. Lyakhovsky, Z. Nazarov with the participation of A. Vershinin. Until 1992 - \"Himicheskaya promyshlennost\".",
    "category": "Павильоны и сооружения",
    "width": "4.7",
    "height": "6",
    "left": "29.6",
    "top": "21",
    "borderRadius": "25",
    "transform": "54",
    "transformImage": "-54",
    "marginTop": "-2",
    "marginRight": "1",
    "marginBot": "0",
    "marginLeft": "0",
    "media": {
      "width": "5.2",
      "height": "3.2",
      "left": "21",
      "top": "16.1",
      "borderRadius": "50",
      "transform": "-11",
      "transformImage": "11",
      "marginTop": "-2",
      "marginRight": "0",
      "marginBot": "0",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №20. «Центральный дом автоспорта».jpg`,
    "id": 21
  },
  {
    "name": "Павильон №23",
    "name_eng": "Pavilion №23",
    "description": "\"Москвариум\" — центр океанографии и морской биологии, один из крупнейших океанариумов Европы. Со дня открытия в 2015 году центр входит в число наиболее популярных мест для семейного отдыха и проведения мероприятий. В экспозиции \"Аквариум\" живут более 12 000 водных обитателей: акулы, нерпы, скаты, черепахи, кайманы, осьминог и сотни видов рыб. Главными звездами водных представлений являются дельфины, моржи, морские львы и красавицы-косатки. Здесь можно провести целый день: юные и взрослые посетители познают удивительную фауну Мирового океана и прикоснутся к удаленным акваториям планеты. \"Москвариум\" — это не только место для отдыха, но и познавательная площадка с исключительными условиями для научной работы по изучению биоразнообразия морей. Крупнейший столичный центр океанографии и морской биологии — \"Москвариум\" — состоит их трех основных зон. Экспозиция \"Аквариум\" включает в себя 80 аквариумов, в которых воссозданы водные экосистемы из самых разных уголков планеты. Посетители могут увидеть более 12 000 морских и речных обитателей, среди которых байкальские нерпы, белуги, осетры, каймановые крокодилы, водные черепахи, осьминог, крабы, экзотические рыбы, мурены и другие. Пространство \"Аквариума\" делится на тематические зоны: пресные и морские воды России, водоемы Африки, Южной Америки, рифовый зал и многие другие. Особое место в аквариуме занимает крупнейшая в России экспозиция осетровых рыб: белуг, калуг, русских осетров, севрюг и стерлядей. Живой интерес у посетителей вызывают сеансы кормления нерп, карпов, пираний и других обитателей аквариума (график кормлений представлен на сайте \"Москвариума\"), интерактивная зона, где можно дотронуться руками до мечехвостов и морских звезд, морской тоннель с проплывающими над головой гигантскими акулами. А одним из самых волшебных приключений в экспозиции станет наблюдение за подводным плаванием Русалки в панорамном аквариуме с крупнейшими в мире пресноводными рыбами – арапаймами (сеансы проводятся по выходным). Увлекательные экскурсии и квесты по экспозиции аквариума, познавательные занятия в лектории и творческие мастер-классы дополнят впечатления от пребывания в одном из крупнейших океанариумов Европы. Зрительный зал для водных шоу – это оборудованная по последнему слову техники площадка для выступления морских животных, рассчитанная на 2300 мест. Она объединяет огромный бассейн и суперсовременный зрительный зал со сценой. При проектировании комплекса учитывались требования безопасности и зрелищности представления. Для создания эффекта присутствия задействовано более 20 установок: 10 приборов для пускания пузырей, 8 машин для генерации снега, 2 устройства, создающих белый дым над водой, и мощнейшие вентиляторы для ветра. \"Москвариум\" в цифрах: более 10 млн человек с момента открытия; площадь комплекса — 53 тыс. кв. м; количество морских и пресноводных обитателей — более 12 тыс.; морские млекопитающие: 6 видов — моржи, морские львы, белуха, дельфины, косатки и байкальские нерпы; общий объем воды — более 25 млн л; вместительность зрительного зала — 2300 мест. Бесплатная маршрутка отправляется от метро ВДНХ, выход из последнего вагона из центра.",
    "description_eng": "\"Moskvarium\" is a centre of oceanography and marine biology, one of the largest oceanariums in Europe. Since its opening in 2015, the centre has been among the most popular places for family recreation and events. More than 12,000 aquatic inhabitants live in the \"Aquarium\" exposition: sharks, seals, rays, turtles, caimans, octopus and hundreds of species of fish. The main stars of aquatic performances are dolphins, walruses, sea lions and beautiful killer whales. You can spend the whole day here: young and adult visitors will get to know the amazing fauna of the World Ocean and touch the remote water areas of the planet. \"Moskvarium\" is not only a place for recreation, but also an educational platform with exceptional conditions for scientific work on the study of biodiversity of the seas. \"Moskvarium\", the largest centre of oceanography and marine biology in the capital, consists of three main zones. The \"Aquarium\" exposition includes 80 aquariums where aquatic ecosystems from different parts of the world are recreated. Visitors can see more than 12,000 sea and river inhabitants, including Baikal seals, belugas, sturgeons, caiman crocodiles, water turtles, octopus, crabs, exotic fish, moray eels and others. The space of the Aquarium is divided into thematic zones: fresh and sea waters of Russia, water bodies of Africa, South America, reef hall and many others. A special place in the aquarium is occupied by the largest exposition of sturgeon fish in Russia: belugas, kalugas, Russian sturgeons and sterlets. Seals, carps, piranhas and other aquarium inhabitants (the feeding schedule is available on the \"Moskvarium\" website), an interactive zone where you can touch swordtails and starfish with your hands, a sea tunnel with giant sharks swimming above your head are of great interest to visitors. And one of the most magical adventures in the exposition will be watching the underwater swimming of Mermaid in the panoramic aquarium with the world's largest freshwater fish - arapaima (sessions are held on weekends). Fascinating excursions and quests around the aquarium exposition, informative lectures and creative master-classes will complete the experience of staying in one of the largest oceanariums in Europe. The auditorium for water shows is a state-of-the-art marine animal performance area with a seating capacity of 2,300. It combines a huge swimming pool and an ultramodern auditorium with a stage. When designing the complex, the requirements for safety and spectacularity of the performance were taken into account. To create the effect of presence more than 20 installations are involved: 10 devices for blowing bubbles, 8 machines for generating snow, 2 devices that create white smoke over the water, and the most powerful fans for wind. \"Moskvarium\" in figures: more than 10 million people since its opening; the area of the complex - 53 thousand square metres; the number of marine and freshwater inhabitants - more than 12 thousand; marine mammals: 6 species - walruses, sea lions, beluga whales, dolphins, killer whales and Baikal seals; total volume of water - more than 25 million litres; capacity of the auditorium - 2300 seats. Free shuttle bus leaves from VDNH metro station, exit from the last carriage from the centre.",
    "category": "Павильоны и сооружения",
    "width": "9.1",
    "height": "6.9",
    "left": "14.4",
    "top": "20.5",
    "borderRadius": "67",
    "transform": "0",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "2",
    "marginLeft": "0",
    "media": {
      "width": "7.1",
      "height": "4.9",
      "left": "10.4",
      "top": "15.3",
      "borderRadius": "67",
      "transform": "0",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "2",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №23. «Москвариум».jpg`,
    "id": 22
  },
  {
    "name": "Павильон №25 \"Нефть\"",
    "name_eng": "Pavilion №25 \"Neft\"",
    "description": "Обновленный павильон \"Нефть\" знакомит посетителей с полным производственным циклом вертикально-интегрированной нефтяной компании — от добычи до переработки и реализации. При этом весь контент и образовательная программа центра доступны для понимания широкому кругу посетителей — от школьников до профильных специалистов. Самая большая мультимедийная экспозиция о нефти в России тематически делится на 4 зала: \"Человек и нефть\", \"История\", \"Технологии\", \"Наука\". В оформлении центра использованы передовые технологические решения: виртуальная и дополненная реальность, голографический театр, а также современные phygital-решения на стыке цифрового и физического мира. Экспозиция включает в себя мультимедийные интерактивные инсталляции, игровые приложения и уникальные анимационные фильмы. Для образовательной и просветительской программ предусмотрен многофункциональный зал с зоной для учебных занятий и просмотра научно-образовательного кино. Павильон построен в 1954 году. Архитекторы А. А. Таций, С. С. Ганешин, И. М. Тамаркин. В 1954‒1955 годах — \"Сахарная свекла\", в 1956‒1957 годах — \"Сахар\", в 1958 году — \"Геология, нефть, газ\", в 1959‒1963 годах — \"Нефть, газ\", в 1963‒1964 годах — \"Топливная промышленность\".",
    "description_eng": "The renovated \"Neft\" pavilion introduces visitors to the full production cycle of a vertically integrated oil company - from production to refining and sales. At the same time, all the content and educational programme of the centre are accessible to a wide range of visitors - from schoolchildren to industry specialists. The largest multimedia exposition about oil in Russia is thematically divided into 4 halls: \"Chelovek i neft\", \"Istoriya\", \"Tehnologii\", \"Nauka\". The design of the centre uses advanced technological solutions: virtual and augmented reality, holographic theatre, as well as modern phygital solutions at the intersection of the digital and physical world. The exposition includes multimedia interactive installations, game applications and unique animated films. For educational and outreach programmes, a multifunctional hall with a zone for training sessions and viewing of scientific and educational films is provided. The pavilion was built in 1954. Architects A. A. Tatsiy, S. S. Ganeshin and I. M. Tamarkin. In 1954-1955 - \"Saharnaya svekla\", in 1956-1957 - \"Sahar\", in 1958 - \"Geologiya, neft, gaz\", in 1959-1963 - \"Neft, gaz\", in 1963-1964 - \"Toplivnaya promyshlennost\".",
    "category": "Павильоны и сооружения",
    "width": "4.2",
    "height": "5.4",
    "left": "19.75",
    "top": "16.3",
    "borderRadius": "42",
    "transform": "-83",
    "transformImage": "83",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "0",
    "marginLeft": "2",
    "media": {
      "width": "3.2",
      "height": "4.1",
      "left": "14.4",
      "top": "12",
      "borderRadius": "54",
      "transform": "-75",
      "transformImage": "75",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "0",
      "marginLeft": "2"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №25 «Нефть».jpg`,
    "id": 23
  },
  {
    "name": "Павильон №26. Музей транспорта Москвы",
    "name_eng": "Pavilion №26. Moscow Transport Museum",
    "description": "Портик павильона — объект культурного наследия федерального значения. Павильон №26 на ВДНХ — флагманская площадка Музея транспорта Москвы, где проводятся масштабные выставки и временные экспозиции. В лектории музея проходят лекции, паблик-токи, кинопоказы и детские мастер-классы, посвященные истории и развитию транспорта. Музей транспорта Москвы — это открытое городское пространство и живой исследовательский центр, отвечающий на важный вопрос: что движет Москвой? Как и сама транспортная система города, музей вплетен в городское пространство, создавая культурное и общественное поле для исследований. В фондах Музея транспорта Москвы находятся более 250 экземпляров легковых и грузовых автомобилей, такси, автобусов, троллейбусов, машин городских служб, вело- и мототехника. В рамках уникальной экскурсии в фонды хранения музей открывает посетителям обширную часть коллекции музея: более 100 единиц легковой, грузовой и городской техники, обслуживающей транспортную систему СССР: автомобили такси и милиции, редкие модификации \"Москвичей\", автобусы, троллейбусы и легендарные машины 1980-х, знакомые многим с детства. Экспонаты коллекции музея можно увидеть на выставочных проектах, а также в транспортной инфраструктуре города. В конце 2024 года постоянная экспозиция музея будет размещена в гараже Константина Мельникова на Новорязанской улице, 27. Сейчас памятник архитектуры советского авангарда находится на реставрации. Ему будет возвращен исторический облик. Павильон построен в 1937 году, реконструирован в 1954 году по проекту П. П. Ревякина, А. М. Громова, В. Ф. Туканова, И. А. Игнатьевой. До 1938 года — \"Зерно\", в 1938–1954 годах — \"Хлопок\", в 1954–1955 годах — \"Земледелие\", в 1956–1957 годах — \"Геология, нефть, химия\", в 1958–1966 годах — \"Химическая промышленность\". С 1967 года — \"Транспорт СССР\".",
    "description_eng": "The pavilion portico is an object of cultural heritage of federal significance. Pavilion №26 at VDNH is the flagship site of the Moscow Transport Museum, where large-scale exhibitions and temporary expositions are held. The museum's lecture hall hosts lectures, public talks, film screenings and children's master classes dedicated to the history and development of transport. The Moscow Transport Museum is an open urban space and a living research centre that answers the important question: what drives Moscow? Like the city's transport system itself, the museum is woven into the urban space, creating a cultural and public field for research. In the funds of the Museum of Transport of Moscow there are more than 250 examples of cars and trucks, taxis, buses, trolleybuses, cars of city services, bicycle and motorbike equipment. Within the framework of the unique excursion to the storage funds the museum opens to visitors a vast part of the museum collection: more than 100 units of cars, trucks and city vehicles serving the transport system of the USSR: taxi and police cars, rare modifications of \"Moskvichi\", buses, trolleybuses and legendary cars of the 1980s, familiar to many since childhood. Exhibits of the museum collection can be seen at exhibition projects, as well as in the transport infrastructure of the city. At the end of 2024 the permanent exposition of the museum will be placed in the garage of Konstantin Melnikov at 27 Novobiazanskaya Street. Now the monument of Soviet avant-garde architecture is under restoration. It will be restored to its historical appearance. The pavilion was built in 1937 and reconstructed in 1954 according to the project of P. P. Revyakin, A. M. Gromov, V. F. Tukanov and I. A. Ignatyeva. Until 1938 - \"Zerno\", in 1938-1954 - \"Hlopok\", in 1954-1955 - \"Zemledelie\", in 1956-1957 - \"Geologija, neft, himiya\", in 1958-1966 - \"Himicheskaya promyshlennost\". Since 1967 - \"Transport SSSR\".",
    "category": "Павильоны и сооружения",
    "width": "4.2",
    "height": "5.8",
    "left": "25.75",
    "top": "15.6",
    "borderRadius": "42",
    "transform": "-83",
    "transformImage": "83",
    "marginTop": "0",
    "marginRight": "-1.5",
    "marginBot": "0",
    "marginLeft": "0",
    "media": {
      "width": "3.2",
      "height": "4.1",
      "left": "18.95",
      "top": "11.6",
      "borderRadius": "54",
      "transform": "-75",
      "transformImage": "75",
      "marginTop": "0",
      "marginRight": "-1.5",
      "marginBot": "0",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №26. Музей Транспорта Москвы.jpg`,
    "id": 24
  },
  {
    "name": "Павильон №29. Эколого-просветительский центр \"Цветоводство\"",
    "name_eng": "Pavilion №29. Ecological and Educational Centre \"Cvetovodstvo\"",
    "description": "В павильоне №29 открыт эколого-просветительский центр \"Цветоводство\" ГПБУ \"Мосприрода\" — интерактивное экспозиционно-выставочное пространство, где посетители могут познакомиться с объектами флоры и фауны вживую и посредством современных цифровых технологий. В экоцентре находятся экспозиционно-выставочная зона садов, арт-павильон \"Метаморфозы природы\", инсталляция \"Что вырастет?\", инсталляция \"Цветочная картотека России\", голографический кинотеатр, историческая выставка, кинотеатр-лекторий, кафе-оранжерея, торговые павильоны. Павильон построен в 1939 году, реконструирован в 1954 году по проекту В. М. Бочкаревой. Павильон спроектирован в стиле советского модернизма, его экспозиции знакомили посетителей с достижениями лучших озеленительных организаций, проектных институтов, цветоводческих хозяйств и ботанических садов. На фасаде размещен объект культурного наследия регионального значения — декоративный рельеф \"Флора\" авторства В. Б. Эльконина и Ю. В. Александрова. В 2021 году в павильоне открыт экоцентр \"Цветоводство\". В павильоне проводятся ландшафтные фестивали, лекции, семинары, выставки и мастер-классы в области экологии, цветоводства, озеленения и формирования комфортной городской среды.",
    "description_eng": "Pavilion №29 is home to the \"Cvetovodstvo\" GPBU \"Mospriroda\" State Unitary Enterprise, an interactive exposition and exhibition space where visitors can get acquainted with the objects of flora and fauna both live and through modern digital technologies. The eco-centre includes an exposition and exhibition area of gardens, an art pavilion \"Metamorfozy prirody\", an installation \"Chto vyrastet?\", an installation \"Cvetochnaja kartoteka Rossii\", a holographic cinema, a historical exhibition, a cinema-lecture hall, a cafe-orangery, and shopping pavilions. The pavilion was built in 1939 and reconstructed in 1954 according to the project of V. M. Bochkareva. The pavilion was designed in the style of Soviet modernism, its expositions introduced visitors to the achievements of the best landscaping organisations, design institutes, floriculture farms and botanical gardens. The facade houses a cultural heritage object of regional significance - a decorative relief \"Flora\" by V.B. Elkonin and Y.V. Aleksandrov. In 2021, the \"Cvetovodstvo\" ecocentre was opened in the pavilion. The pavilion hosts landscape festivals, lectures, seminars, exhibitions and master classes in the field of ecology, floriculture, landscaping and formation of a comfortable urban environment.",
    "category": "Павильоны и сооружения",
    "width": "6.6",
    "height": "2.8",
    "left": "12.6",
    "top": "9.7",
    "borderRadius": "44",
    "transform": "27",
    "transformImage": "-27",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "1",
    "marginLeft": "0.5",
    "media": {
      "width": "4.4",
      "height": "2.3",
      "left": "9.5",
      "top": "7.3",
      "borderRadius": "44",
      "transform": "19",
      "transformImage": "-19",
      "marginTop": "0",
      "marginRight": "0.5",
      "marginBot": "2",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №29 Эколого-просветительский центр Цветоводство.jpg`,
    "id": 26
  },
  {
    "name": "Павильон №30. Центр современных биотехнологий Музей \"Биотех\"",
    "name_eng": "Pavilion №30. Centre for Modern Biotechnology \"Biotech\" Museum",
    "description": "20 мая 2022 года в отреставрированном историческом павильоне №30 открылся Центр современных биотехнологий Музей \"Биотех\". При поддержке Минобрнауки России ФИЦ Биотехнологии РАН создал уникальную площадку, которая позволит нескучно рассказать и наглядно показать, что же такое современные биотехнологии, какие прикладные сферы их применения есть уже сегодня, а какие — дело ближайшего будущего. Посетители смогут взаимодействовать с экспонатами, участвовать в интерактивных викторинах и игровых объектах, однако даже такие развлечения будут насыщены полезной информацией, тщательно выверенной учеными. Детально продуманная экспозиция научно-популярного музея призвана доступно и интересно объяснить, какие преимущества несут новые биотехнологические разработки, как работают системы создания вакцин, сити-фермы, биореакторы и многие другие инновационные и ставшие привычными технологии. Посетители смогут потрогать новые материалы, произведенные с использованием биотехнологий (от шелка до бетона), увидеть привычные продукты питания, произведенные из нетрадиционного сырья (\"мясо из пробирки\", \"мука из кузнечиков\", \"грибной сыр\"), с помощью интерактивной инсталляции разобраться, как происходит процесс разложения пластика в природных условиях и с применением биотехнологических методов, а также понаблюдать за звездным свечением биолюминесцентных растений. Помимо постоянной экспозиции музея, в павильоне будет также функционировать зона для проведения мероприятий различных форматов — семинаров, мастер-классов, лекций, тематических конференций, студийных съемок. Музей \"Биотех\" встречает посетителей зоной входной группы, где располагаются два тематических экспоната (один из них выполнен в виде фотозоны) и сувенирная лавка. Через \"темный\" коридор, погружающий посетителей в глобальные проблемы, с которыми сталкивается человечество, можно пройти в основной зал музея. Экспозиция насчитывает более 14 уникальных экспонатов, позволяющих рассказать в научно-познавательном формате о влиянии биотехнологий как на нашу планету в целом, так и на жизнь каждого человека. Инсталляции созданы так, чтобы посетитель мог и визуально, и тактильно, и деятельно взаимодействовать с экспонатами и таким образом четче понимать принципы, на которых основан современный биотех, а также прикладные преимущества его внедрения. На выходе из основного зала посетитель попадает в \"светлый\" коридор, экспозиция которого демонстрирует, каким может стать мир при грамотном внедрении биотехнологий. Созданное в павильоне №30 на ВДНХ пространство — точка притяжения для всех, кто заинтересован в развитии отечественной науки и промышленности, кто хочет разобраться в сложных вещах, принимать взвешенные решения, основываясь на мощной доказательной базе, а также для молодежи, которая заинтересована в новых знаниях или планирует связать свою жизнь с передовыми направлениями науки. Павильон построен в 1939 году. Реконструирован в 1954 году по проекту В. М. Бочкаревой. В 1937–1938 годах — \"Эфироносы\". В 1939–1953 годах — \"Масличные культуры\". В 1954–1958 годах — \"Хлопок\". В 1959 году — \"Хлопчатобумажная и льняная промышленность\". В 1960–1964 годах — \"Текстильная промышленность\". Главный фасад павильона — объект культурного наследия федерального значения.",
    "description_eng": "On 20 May 2022, the Centre for Modern Biotechnology opened the \"Biotech\" Museum in the restored historic Pavilion №30. With the support of the Ministry of Education and Science of Russia, the FRC Biotechnology RAS has created a unique platform that will allow to tell and show in a non-boring way what modern biotechnologies are, what applied areas of their application are already available today, and which ones are the matter of the near future. Visitors will be able to interact with the exhibits, participate in interactive quizzes and game objects, but even such entertainment will be full of useful information, carefully verified by scientists. The detailed exposition of the popular science museum is designed to explain in an accessible and interesting way the advantages of new biotechnological developments, how vaccine creation systems, city-farms, bioreactors and many other innovative and familiar technologies work. Visitors will be able to touch new materials produced with the use of biotechnology (from silk to concrete), see familiar food products made from non-traditional raw materials (\"meat from a test tube\", \"flour from grasshoppers\", \"mushroom cheese\"), with the help of an interactive installation to understand how the process of plastic decomposition occurs in natural conditions and with the use of biotechnological methods, as well as to observe the star glow of bioluminescent plants. In addition to the museum's permanent exposition, the pavilion will also feature an area for events of various formats - seminars, master classes, lectures, thematic conferences, and studio shootings. The \"Biotech\" Museum welcomes visitors with an entrance area with two thematic exhibits (one of them is made in the form of a photo zone) and a souvenir shop. Through the \"dark\" corridor, immersing visitors in the global problems faced by mankind, one can pass to the main hall of the museum. The exposition has more than 14 unique exhibits that allows to tell in a scientific and cognitive format about the impact of biotechnology on our planet as a whole and on the life of each person. The installations are designed in such a way that the visitor can interact with the exhibits visually, tactilely and actively and thus better understand the principles on which modern biotech is based, as well as the applied benefits of its implementation. At the exit from the main hall, the visitor enters the \"light\" corridor, the exposition of which demonstrates how the world can become with the proper implementation of biotechnology. The space created in Pavilion №30 at VDNH is a point of attraction for all those interested in the development of domestic science and industry, who want to understand complex things, make informed decisions based on a strong evidence base, as well as for young people who are interested in new knowledge or plan to link their lives with advanced areas of science. The pavilion was built in 1939. Reconstructed in 1954 according to the project by V. M. Bochkareva. In 1937-1938 - \"Ephyronosy\". In 1939-1953 - \"Maslichnye kultury\". In 1954-1958 - \"Hlopok\". In 1959 - \"Hlopchatobumazhnaya i lnyanaya promyshlennost\". In 1960-1964 - \"Tekstilnaya promyshlennost\". The main facade of the pavilion is an object of cultural heritage of federal significance.",
    "category": "Павильоны и сооружения",
    "width": "4.6",
    "height": "2.8",
    "left": "14.6",
    "top": "13.1",
    "borderRadius": "44",
    "transform": "0",
    "marginTop": "-2",
    "marginRight": "0",
    "marginBot": "0",
    "marginLeft": "0",
    "media": {
      "width": "3.4",
      "height": "2.3",
      "left": "10.8",
      "top": "9.6",
      "borderRadius": "44",
      "transform": "0",
      "marginTop": "-2",
      "marginRight": "0",
      "marginBot": "0",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №30. Центр современных биотехнологий Музей «Биотех».jpeg`,
    "id": 27
  },
  {
    "name": "Павильон №31 \"Геология\". Биологический музей им. К.А.Тимирязева",
    "name_eng": "Pavilion №31 \"Geologiya\". Biological museum named after K.A.Timiryazev",
    "description": "В павильоне №31 \"Геология\" работает выставка \"12 признаков живого\" Государственного биологического музея имени К. А. Тимирязева. Экспозиция выстроена как захватывающее повествование от лица ученых-биологов и современных художников о том, как все существующее на планете Земля и даже за ее пределами связано друг с другом. Посетители узнают о 12 признаках, по которым ученые отличают живое от неживого, и проследуют по соответствующим частям экспозиции: \"Единство химического состава\", \"Единство структурной организации\", \"Целостность (непрерывность) и дискретность (прерывность)\", \"Многообразие жизни\", \"Обмен веществ и энергии\", \"Живой организм — открытая система\", \"Раздражимость\", \"Движение\", \"Ритмичность\", \"Размножение\", \"Наследственность и изменчивость\", \"Рост и развитие\". Гости экспозиции увидят коллекции Биологического музея – минералы, чучела и скелеты, муляжи редких сортов овощей и фруктов, а также объекты современного искусства, большая часть которых создана специально для выставки. Также для погружения в тему разработан мультимедийный гид с дополненной реальностью. Павильон №31 находился на реставрации с 2018 года. Специалисты восстановили отделку фасадов цветной декоративной штукатуркой, были отреставрированы боковые двери главного фасада, воссозданы все оконные и дверные блоки. Также были воссозданы дубовый паркет, а по историческим фотографиям и чертежам — уникальные люстры выставочных залов. Павильон построен в 1954 году. Архитектор — Л. Н. Павлов. До 1956 года — \"Лен, конопля и другие лубяные культуры\". В 1956–1957 годах — \"Лубяная и шерстяная промышленность\". В 1958 году — \"Льняная и шерстяная промышленность\". С 1959 года — \"Геология\". Объект культурного наследия федерального значения.",
    "description_eng": "The exhibition \"12 priznakov zhivogo\" of the K. A. Timiryazev State Biological Museum is running in Pavilion №31 \"Geologiya\". The exposition is structured as an exciting narrative on behalf of biologists and contemporary artists about how everything existing on the planet Earth and even beyond its borders is connected with each other. Visitors will learn about the 12 attributes that scientists use to distinguish living things from non-living things and follow the corresponding parts of the exhibit: \"Edinstvo himicheskogo sostava\", \"Edinstvo strukturnoy organizacii\", \"Celostnost (nepreryvnost) i diskretnost (preryvnost)\", \"Mnogoobrazie zhizni\", \"Obmen veshhestv i energii\", \"Zhivoy organizm — otkrytaya sistema\", \"Razdrazhimost\", \"Dvizhenie\", \"Ritmichnost\", \"Razmnozhenie\", \"Nasledstvennost i izmenchivost\", \"Rost i razvitie\". Guests of the exposition will see the collections of the Biological Museum - minerals, stuffed animals and skeletons, moulages of rare varieties of fruits and vegetables, as well as objects of modern art, most of which were created especially for the exhibition. A multimedia guide with augmented reality was also developed for immersion in the theme. Pavilion №31 has been under restoration since 2018. Specialists restored the facade finish with coloured decorative plaster, the side doors of the main facade were restored, and all window and door units were recreated. The oak parquet was also recreated, and the unique chandeliers of the exhibition halls were recreated according to historical photographs and drawings. The pavilion was built in 1954. The architect was L.N. Pavlov. Until 1956 - \"Len, konoplya i drugie lubyanye kultury\". In 1956-1957 - \"Lubyanaya i sherstyanaya promyshlennost\". In 1958 - \"Lnyanaya i sherstyanaya promyshlennost\". Since 1959 - \"Geologiya\". An object of cultural heritage of federal significance.",
    "category": "Павильоны и сооружения",
    "width": "3.6",
    "height": "3",
    "left": "20",
    "top": "13.4",
    "borderRadius": "39",
    "transformImage": "0",
    "marginTop": "0",
    "marginRight": "1",
    "marginBot": "2",
    "marginLeft": "0",
    "media": {
      "width": "2.5",
      "height": "2.5",
      "left": "14.7",
      "top": "9.6",
      "borderRadius": "100",
      "transform": "",
      "marginTop": "0",
      "marginRight": "1",
      "marginBot": "2",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №31 «Геология». Биологический музей им. К.А.Тимирязева.jpeg`,
    "id": 28
  },
  {
    "name": "Павильон №34. Центр \"Космонавтика и авиация\"",
    "name_eng": "Pavilion №34. Centre \"Kosmonavtika i aviaciya\"",
    "description": "В центре \"Космонавтика и авиация\" можно увидеть более 120 уникальных образцов летательной и космической техники, экспонаты оборонно-промышленных предприятий, свыше 2 тысяч редких архивных документов, фотографий и видеоматериалов об истории космических достижений. Также в павильоне работает сувенирный магазин ВДНХ. В отреставрированном павильоне \"Космос\" работает музейный комплекс мирового уровня — центр \"Космонавтика и авиация\". Огромное выставочное пространство, посвященное отечественной истории освоения космоса, стало важнейшим этапом возрождения Выставки. Павильон построен в 1939 году. Архитекторы — И. Г. Таранов, В. С. Андреев, Н. А. Быкова. Скульптуры и барельефы — С. Д. Меркуров (1881–1952). Реконструирован в 1954 году по проекту архитекторов В. С. Андреева, И. Г. Таранова. Главный конструктор — М. М. Лимановский, конструктор купола — Г. Б. Гордон. В результате реконструкции единое здание павильона имело двойной номер — №32–34. До 1954 года — \"Механизация\". В 1954–1956 годах — \"Механизация и электрификация сельского хозяйства СССР\". В 1956–1966 годах — \"Машиностроение\". Объект культурного наследия федерального значения.",
    "description_eng": "The \"Kosmonavtika i aviaciya\" centre displays over 120 unique samples of aircraft and space equipment, exhibits of defence and industrial enterprises, over 2 thousand rare archive documents, photos and videos about the history of space achievements. The pavilion also houses the VDNH souvenir shop. The restored \"Cosmos\" pavilion houses a world-class museum complex - the \"Kosmonavtika i aviaciya\" centre. The huge exhibition space dedicated to the national history of space exploration became the most important stage of the Exhibition's revival. The pavilion was built in 1939. The architects were I. G. Taranov, V. S. Andreev and N. A. Bykova. Sculptures and bas-reliefs by S. D. Merkurov (1881-1952). Reconstructed in 1954 according to the project of architects V. S. Andreev, I. G. Taranov. The chief designer was M. M. Limanovsky, the dome designer was G. B. Gordon. As a result of the reconstruction, the single pavilion building had a double number - №32-34. Until 1954 - \"Mehanizaciya\". In 1954-1956 - \"Mehanizaciya i elektrifikaciya selskogo hozaystva SSSR\". In 1956-1966 - \"Mashinostroenie\". An object of cultural heritage of federal significance.",
    "category": "Павильоны и сооружения",
    "width": "",
    "height": "",
    "left": "",
    "top": "",
    "borderRadius": "100",
    "transform": "",
    "media": {
      "width": "",
      "height": "",
      "left": "",
      "top": "",
      "borderRadius": "100",
      "transform": ""
    },
    "hidden": true,
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №34. Центр «Космонавтика и авиация».jpg`,
    "id": 29,
    "entranceTeleportId": 100

  },
  {
    "name": "Павильон №55. Музей оптических иллюзий",
    "name_eng": "Pavilion №55. Museum of optical illusions",
    "description": "Партнерами проектов, реализуемых в павильоне №55, являются LEGO Education Россия и СНГ, Smile Park Москва, Правительство Москвы. В павильоне №55 на ВДНХ находится универсальная конгрессно-выставочная, развлекательная, интерактивная площадка Smile Park. Это 11 аттракционов, квестов, лабиринтов и музеев — уникальное развлекательное пространство в Москве для настоящих любителей повеселиться: \"Музей иллюзий\"; \"Дом великана\"; \"Перевернутый город\"; музей \"Внутри человека\"; \"Побег из тюрьмы\"; лабиринт страха \"Зов ада\"; зеркальный лабиринт; стеклянный лабиринт; антистресс \"Бей посуду!\"; бассейн с мячиками; ленточный лабиринт. В Smile Park можно отпраздновать незабываемый день рождения, отметить выпускной детского сада или школы. Павильон построен в 1939 году. Реконструирован в 1967 году по проекту Л. И. Браславского. До 1959 года — \"Животноводство\".",
    "description_eng": "The partners of the projects implemented in Pavilion №55 are LEGO Education Russia and CIS, Smile Park Moscow, and the Moscow City Government. Pavilion №55 at VDNH houses Smile Park, a universal congress and exhibition, entertainment and interactive platform. These are 11 attractions, quests, mazes and museums - a unique entertainment space in Moscow for real fun lovers: \"Muzey illuziy\"; \"Dom velikana\"; \"Perevernuty gorod\"; museum \"Vnutri cheloveka\"; \"Pobeg iz tyurmy\"; fear maze \"Zov ada\"; mirror maze; glass maze; anti-stress \"Bey posudu!\"; pool with balls; ribbon maze. In Smile Park you can celebrate an unforgettable birthday or the graduation of a kindergarten or school. The pavilion was built in 1939. It was reconstructed in 1967 according to the project of L.I. Braslavsky. Until 1959 - \"Zhivotnovodstvo\".",
    "category": "Павильоны и сооружения",
    "width": "7.6",
    "height": "4.3",
    "left": "32",
    "top": "9.7",
    "borderRadius": "36",
    "transform": "24",
    "transformImage": "-24",
    "marginTop": "0",
    "marginRight": "1",
    "marginBot": "2",
    "marginLeft": "0",
    "media": {
      "width": "5.6",
      "height": "3",
      "left": "23.6",
      "top": "7.1",
      "borderRadius": "29",
      "transform": "27",
      "transformImage": "-27",
      "marginTop": "0",
      "marginRight": "1",
      "marginBot": "2",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №55. Музей оптических иллюзий.jpg`,
    "id": 33
  },
  {
    "name": "Павильон №51 \"Мясная промышленность\"",
    "name_eng": "Pavilion №51 \"Myasnaya promyshlennost\"",
    "description": "Павильон закрыт на реставрацию. В будущем здесь планируется организация музейно-выставочной деятельности. Построен в 1954 году по проекту В.М. Лисицына, С.Г. Чернобай.  До 1956 года — \"Главмясо\".  Объект культурного наследия федерального значения.",
    "description_eng": "The pavilion is closed for restoration. It is planned to organise museum and exhibition activities here in the future. Built in 1954 by V.M. Lisitsyn and S.G. Chernobay.  Before 1956 - \"Glavmyaso\". An object of cultural heritage of federal significance.",
    "category": "Павильоны и сооружения",
    "width": "3.6",
    "height": "2",
    "left": "19",
    "top": "5.8",
    "borderRadius": "44",
    "transform": "29",
    "transformImage": "-29",
    "marginTop": "0",
    "marginRight": "1",
    "marginBot": "2",
    "marginLeft": "0",
    "media": {
      "width": "2.6",
      "height": "1.6",
      "left": "14",
      "top": "4.2",
      "borderRadius": "44",
      "transform": "24",
      "transformImage": "-24",
      "marginTop": "0",
      "marginRight": "1",
      "marginBot": "2",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №51. «Мясная промышленность».jpg`,
    "id": 37
  },
  {
    "name": "Павильон №53-54. Музей Гаража особого назначения ФСО России",
    "name_eng": "Pavilion №53-54. Museum of the special purpose garage of the Federal Protective Service of Russia",
    "description": "В музее представлены легендарные машины лидеров Российской империи, Советского Союза и Российской Федерации. Каждый автомобиль — свидетель эпохи: от императорских Delaunay-Belleville и Mercedes до современных автомобилей Aurus, от советских моделей ЗИС и ЗИЛ до мотоциклов Почетного эскорта. Среди центральных экспонатов — автомобиль Aurus Senat Limousine, доставивший Президента России В. В. Путина на церемонию инаугурации в мае 2018 года. Для детей проводятся мастер-классы, квесты, брейн-ринг и лекции по истории автомобилестроения, промышленному дизайну и другим инженерным дисциплинам. Все гости могут познакомиться с автомобилями Гаража особого назначения и мотоциклами Почетного эскорта, оценить интерактивные экспонаты и посидеть в салонах легендарных автомобилей. В январе 2021 года Гараж особого назначения Федеральной службы охраны Российской Федерации отметил столетний юбилей. К этому событию было приурочено открытие многофункционального музейно-выставочного комплекса \"Музей Гаража особого назначения\" в двух павильонах на территории ВДНХ. Созданный музей стал главным хранителем истории легендарного подразделения и центром изучения мирового автомобилестроения. Павильон построен в 1954 году. Архитекторы — А. О. Колесниченко, Г. Г. Савинов.",
    "description_eng": "The museum presents legendary cars of the leaders of the Russian Empire, the Soviet Union and the Russian Federation. Each car is a witness of the era: from imperial Delaunay-Belleville and Mercedes to modern Aurus cars, from Soviet ZIS and ZIL models to motorbikes of the Escort of Honour. Among the centrepieces is the Aurus Senat Limousine, which transported Russian President Vladimir Putin to the inauguration ceremony in May 2018. There are masterclasses, quests, brain-ringing and lectures on the history of automobile construction, industrial design and other engineering disciplines for children. All guests can get acquainted with the cars of the Garage of Special Purpose and motorbikes of the Escort of Honour, appreciate interactive exhibits and sit in the saloons of legendary cars. In January 2021, the Special Purpose Garage of the Federal Protective Service of the Russian Federation celebrated its centenary. The opening of a multifunctional museum and exhibition complex \"Muzey garazha osobogo naznacheniya\" in two pavilions on the territory of VDNH was timed to coincide with this event. The created museum became the main keeper of the history of the legendary unit and the centre for studying the world automobile industry. The pavilion was built in 1954. Architects - A. O. Kolesnichenko, G. G. Savinov.",
    "category": "Павильоны и сооружения",
    "width": "11.6",
    "height": "3.3",
    "left": "20.5",
    "top": "5.2",
    "borderRadius": "29",
    "transform": "30",
    "transformImage": "-30",
    "marginTop": "0",
    "marginRight": "1",
    "marginBot": "1",
    "marginLeft": "0",
    "media": {
      "width": "8.6",
      "height": "2.5",
      "left": "15.1",
      "top": "3.8",
      "borderRadius": "29",
      "transform": "30",
      "transformImage": "-30",
      "marginTop": "0",
      "marginRight": "1",
      "marginBot": "1",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №53-54. Музей Гаража особого назначения ФСО России.png`,
    "id": 38
  },
  {
    "name": "Павильон №57 \"Россия — моя история\"",
    "name_eng": "Pavilion №57 \"Russia - My History\"",
    "description": "Исторический парк \"Россия — моя история\" — мультимедийный образовательно-выставочный комплекс, который рассказывает о важных периодах формирования и становления государства и культуры нашей страны. Исторический парк \"Россия — моя история\" создан на основе мультимедийных экспозиций \"Рюриковичи\", \"Романовы\", \"ХХ век. 1914–1945 гг. От великих потрясений — к Великой Победе\", \"ХХ век. 1945–2000 гг.\". Первые три из этих экспозиций ранее с большим успехом демонстрировались в Манеже. В экспозициях используются современные технологии музейного показа, в том числе голограммы, интерактивные сенсорные экраны, проекционный купол, видеопанели с трехмерными историческими реконструкциями, аудиогиды. Павильон построен в 1967 году. Архитекторы — И. Виноградский, В. Зальцман, В. Докторович. В 1960-е годы назывался \"Промышленность товаров народного потребления\", до 1992 года — \"Павильон межотраслевых тематических выставок №1\".",
    "description_eng": "The historical park \"Russia - My History\" is a multimedia educational and exhibition complex, which tells about important periods of formation and establishment of the state and culture of our country. The historical park \"Russia - My History\" is based on multimedia expositions \"Rurikovich\", \"Romanovs\", \"XX century. 1914-1945. From great upheavals to the Great Victory\", \"XX century. 1945-2000\". The first three of these expositions were previously demonstrated in the Manege with great success. The expositions use modern museum display technologies, including holograms, interactive touch screens, projection dome, video panels with three-dimensional historical reconstructions, audio guides. The pavilion was built in 1967. Architects - I. Vinogradsky, V. Zaltsman, V. Doctorovich. In the 1960s it was called \"Promyshlennost tovarov narodnogo potrebleniya\", until 1992 it was called \"Pavilion mezhotraslevyh tematicheskih vystavok №1\".",
    "category": "Павильоны и сооружения",
    "width": "10",
    "height": "3",
    "left": "43.8",
    "top": "17.4",
    "borderRadius": "30",
    "transform": "27",
    "transformImage": "-27",
    "marginTop": "0",
    "marginRight": "2",
    "marginBot": "2",
    "marginLeft": "0",
    "media": {
      "width": "7.6",
      "height": "2.3",
      "left": "32.35",
      "top": "12.8",
      "borderRadius": "30",
      "transform": "28",
      "transformImage": "-28",
      "marginTop": "0",
      "marginRight": "2",
      "marginBot": "2",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №57. «Россия — моя история».jpg`,
    "id": 39
  },
  {
    "name": "Павильон №58. Музей славянской письменности \"Слово\"",
    "name_eng": "Pavilion №58. Museum of slavic literature \"Slovo\"",
    "description": "Музей славянской письменности \"Слово\" — музейно-просветительский комплекс для детей и взрослых, не имеющий аналогов в России, своего рода точка притяжения как для любителей русского языка, так и для ценителей архитектуры, культуры и истории. Здесь можно узнать, как развивается письменность в России и мире, какую роль она играет в жизни разных народов и как на протяжении многих веков соприкасается с устной речью. Первая часть экспозиции рассказывает посетителю о возникновении и развитии письменности от древности до наших дней. Вторая — о том, как тексты связаны с духовной, культурной и политической жизнью общества. Третья часть посвящена истории и будущему главных символов письма — букв. Заключительная часть — \"Бесписьменная культура\" — посвящена судьбе устной речи. Здесь рассказывается о фольклоре, языковых особенностях, невербальной коммуникации. Гости могут послушать колыбельные песни и былины и посмотреть видео, находясь в специальных войлочных коконах. До 1964 года павильон назывался \"Украинская ССР\". Объект культурного наследия федерального значения.",
    "description_eng": "The Museum of slavic literature \"Slovo\" is a museum and educational complex for children and adults that has no analogues in Russia, a kind of a point of attraction both for lovers of the Russian language and for connoisseurs of architecture, culture and history. Here you can learn how writing develops in Russia and the world, what role it plays in the life of different peoples and how it has been in contact with oral speech for many centuries. The first part of the exposition tells the visitor about the emergence and development of writing from antiquity to the present day. The second part is about how texts are connected with the spiritual, cultural and political life of society. The third part is devoted to the history and future of the main symbols of writing - letters. The final part, \"Bespismennaya kultura\", is devoted to the fate of oral speech. It tells about folklore, linguistic peculiarities, non-verbal communication. Guests can listen to lullabies and bylinas and watch videos in special felt cocoons. Until 1964 the pavilion was called \"Ukrainskaya SSR\". An object of cultural heritage of federal significance.",
    "category": "Павильоны и сооружения",
    "width": "6.7",
    "height": "4.5",
    "left": "47.5",
    "top": "22.6",
    "borderRadius": "34",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "3",
    "marginLeft": "0",
    "media": {
      "width": "5",
      "height": "3.5",
      "left": "34.9",
      "top": "16.5",
      "borderRadius": "50",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "3",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №58. Музей славянской письменности «Слово».jpg`,
    "id": 2
  },
  {
    "name": "Павильон я \"Потребительская кооперация\"",
    "name_eng": "Pavilion №60 \"Potrebitelskaya kooperaciya\"",
    "description": "Архитектура павильона выдержана в формах неоклассики, гармонично дополненной орнаментами в русском стиле. Полуциркульная колоннада входной группы и бельведер, украшенный золотым венком с ажурной декоративной композицией, придают ему особую торжественность. Павильон построен в 1954 году, архитекторы — В. В. Лебедев и П. П. Штеллер. До 1959 года — \"Центральные черноземные области\", затем, до начала 1980-х годов, — \"Центросоюз\", далее — \"Потребительская кооперация\". Объект культурного наследия федерального значения. В павильоне работает кафе.",
    "description_eng": "The architecture of the pavilion is neoclassical, harmoniously complemented by Russian-style ornaments. The semi-circular colonnade of the entrance group and the belvedere decorated with a golden wreath with openwork decorative composition give it a special solemnity. The pavilion was built in 1954, architects - V. V. Lebedev and P. P. Shteller. Until 1959 - \"Centralnye chernozemnye oblasti\", then, until the early 1980s - \"Centrosoyuz\", then - \"Potrebitelskaya kooperaciya\". An object of cultural heritage of federal significance. There is a café in the pavilion.",
    "category": "Павильоны и сооружения",
    "width": "2.97",
    "height": "2.2",
    "left": "53.35",
    "top": "17.6",
    "borderRadius": "52",
    "transform": "6",
    "transformImage": "-6",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "2",
    "marginLeft": "0",
    "media": {
      "width": "2.2",
      "height": "1.6",
      "left": "39.35",
      "top": "13",
      "borderRadius": "52",
      "transform": "6",
      "transformImage": "-6",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "2",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №60. «Потребительская кооперация».jpeg`,
    "id": 41
  },
  {
    "name": "Павильон №61 \"Центросоюз\"",
    "name_eng": "Pavilion №61 \"Centrosoyuz\"",
    "description": "Белоснежный павильон в стиле арт-деко. После завершения реставрационных работ здесь планируется организация культурно-досуговой деятельности. Павильон построен в 1954 году, архитекторы — Р. Р. Кликс и Б. С. Виленский. Павильон \"Центросоюз\" в рамках ВСХВ был призван демонстрировать значение потребительской кооперации, назначение которой состояло в осуществлении и развитии товарной связи между городом и деревней. В 1959 году в павильоне №61 открылась экспозиция \"Атомная энергия в мирных целях\", а после 1963-го — выставка достижений советской легкой промышленности. Объект культурного наследия федерального значения.",
    "description_eng": "A snow-white pavilion in the Art-Deco style. After the restoration works are completed, it is planned to organise cultural and leisure activities here. The pavilion was built in 1954, architects - R. R. Klix and B. S. Vilensky. The pavilion \"Centrosoyuz\" within the framework of the All-Union Agricultural Exhibition was intended to demonstrate the importance of consumer co-operation, the purpose of which was to implement and develop the commodity link between the city and the countryside. In 1959 in pavilion №61 the exposition \"Atomnaya energiya v mirnyh celyah\" was opened, and after 1963 - the exhibition of achievements of the Soviet light industry. An object of cultural heritage of federal significance.",
    "category": "Павильоны и сооружения",
    "width": "3.4",
    "height": "2.2",
    "left": "53.35",
    "top": "15.4",
    "borderRadius": "52",
    "transform": "6",
    "transformImage": "-6",
    "marginTop": "0",
    "marginRight": "0.5",
    "marginBot": "2",
    "marginLeft": "0",
    "media": {
      "width": "2.4",
      "height": "1.6",
      "left": "39.35",
      "top": "11.4",
      "borderRadius": "52",
      "transform": "6",
      "transformImage": "-6",
      "marginTop": "0",
      "marginRight": "0.5",
      "marginBot": "2",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №61. Центросоюз.jpg`,
    "id": 42
  },
  {
    "name": "Павильон №64 \"Оптика\"",
    "name_eng": "Pavilion №64 \"Optica\"",
    "description": "В 1982 году в павильоне разместилась экспозиция \"Оптика\", рассказывающая о значении, конструировании и практическом применении оптических приборов. На стендах, панелях и витринах павильона были представлены многочисленные как бытовые, так и узкоспециализированные инструменты и оборудование, использующее оптические принципы. В 1990–2000-е годы помещения павильона использовались под торговлю. К началу 2010-х гг. в павильоне остались коммерческие представительства, связанные с продажей оптических средств, произведений живописи и ювелирного искусства. В круглом зале открылось кафе. В 2014 году, во время реконструкции сквера за павильоном, скульптура в бассейне была поднята на более высокий постамент, а количество водных струй увеличено, охватив постамент кольцом. С 2015 по 2017 год павильон использовался как выставочно-демонстрационная площадка для размещения различных временных экспозиций, проведения мероприятий и локальных выставок. С 2018 года павильон закрыт. Павильон построен в 1937–1939 годах по проекту Е. А. Левинсона. В 1949–1954 годах здание было реконструировано при участии архитектора И. З. Вильнера. В 1939–1941 годах — \"Ленинград и Северо-Восток РСФСР\", в 1954–1958 годах — \"Ленинград и Северо-Запад РСФСР\", в 1959–1966 годах — \"Образование в СССР\", в 1967–1982 годах — \"Экономика сельского хозяйства\". Объект культурного наследия федерального значения.",
    "description_eng": "In 1982, the pavilion hosted the \"Optica\" exposition, which told about the significance, construction and practical application of optical instruments. The stands, panels and showcases of the pavilion displayed numerous both household and highly specialised instruments and equipment using optical principles. In the 1990s-2000s the premises of the pavilion were used for trade. By the early 2010s, the pavilion was left with commercial representation related to the sale of optical aids, paintings and jewellery. A café opened in the round hall. In 2014, during the reconstruction of the public garden behind the pavilion, the sculpture in the pool was raised to a higher pedestal and the number of water jets was increased, encompassing the pedestal in a ring. From 2015 to 2017, the pavilion was used as an exhibition and demonstration area to accommodate various temporary displays, events and local exhibitions. Since 2018, the pavilion has been closed. The pavilion was built in 1937-1939 according to the project of E. A. Levinson. In 1949-1954, the building was reconstructed with the participation of architect I. Z. Wilner. In 1939-1941 - \"Leningrad i Severo-Vostok RSFSR\", in 1954-1958 - \"Leningrad i Severo-Zapad RSFSR\", in 1959-1966 - \"Obrazovanie v SSSR\", in 1967-1982 - \"Ekonomika selskogo hozyastva\". An object of cultural heritage of federal significance.",
    "category": "Павильоны и сооружения",
    "width": "5.4",
    "height": "3.6",
    "left": "56.5",
    "top": "23.3",
    "borderRadius": "76",
    "transform": "30",
    "transformImage": "-30",
    "marginTop": "0",
    "marginRight": "1.5",
    "marginBot": "2",
    "marginLeft": "0",
    "media": {
      "width": "4.2",
      "height": "2.6",
      "left": "41.5",
      "top": "17.2",
      "borderRadius": "76",
      "transform": "30",
      "transformImage": "-30",
      "marginTop": "0",
      "marginRight": "1.5",
      "marginBot": "2",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №64. «Оптика».jfif`,
    "id": 43
  },
  {
    "name": "Павильон №67 \"Карелия\"",
    "name_eng": "Pavilion №67 \"Karelia\"",
    "description": "Первой экспозицией этого павильона стала \"Карело-Финская ССР\", насчитывавшая к 1954 году уже немало лет своей собственной истории. На довоенной Выставке материалы, посвященные Карельской АССР, входили в большой тематический раздел \"Ленинград и Северо-Восток РСФСР\", занимавший павильон №64. Павильон построен в 1954 году, архитекторы — Ф. И. Рехмуков, А. Я. Резниченко. До 1957 года — \"Карело-Финская ССР\". В 1957 году — \"Академия наук СССР\". В 1958 году — \"Наука\". В 1959–1963 годах — \"Культура и быт народов РСФСР\". В 1964–1966 годах — \"Целлюлозно-бумажная и лесохимическая промышленность\". Далее — \"Советская печать\". Объект культурного наследия федерального значения.",
    "description_eng": "The first exposition of this pavilion was \"Karelo-Finskaya SSR\", which, by 1954, had many years of its own history. At the pre-war Exhibition, materials devoted to the Karelian ASSR were included in the large thematic section \"Leningrad i Severo-Vostok RSFSR\", which occupied pavilion №64. The pavilion was built in 1954, architects - F. I. Rekhmukov and A. Y. Reznichenko. Until 1957 - \"Karelo-Finskaya SSR\". In 1957 - \"Akademiya nauk SSSR\". In 1958 - \"Nauka\". In 1959-1963 - \"Kultura i byt narodov RSFSR\". In 1964-1966 - \"Cellylozno-bumazhnaya i lesohimicheskaya promyshlennost\". Further - \"Sovetskaya pechat\". An object of cultural heritage of federal significance.",
    "category": "Павильоны и сооружения",
    "width": "3.8",
    "height": "3",
    "left": "72.1",
    "top": "30.7",
    "borderRadius": "47",
    "transform": "-5",
    "transformImage": "5",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "2",
    "marginLeft": "0",
    "media": {
      "width": "2.9",
      "height": "2.3",
      "left": "53.1",
      "top": "22.75",
      "borderRadius": "38",
      "transform": "-23",
      "transformImage": "23",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "2",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №67. Карелия.jpg`,
    "id": 45
  },
  {
    "name": "Павильон №68. Выставочно-торговый центр Республики Армения",
    "name_eng": "Pavilion №68. Exhibition and trade centre of the Republic of Armenia",
    "description": "С 2003 года в павильоне работает выставочно-коммерческий центр Республики Армения, где проходят тематические вечера и национальные праздники. В павильоне работает ресторан \"Арарат\", дегустационный зал, а также магазин армянских продуктов. Павильон построен в 1954 году, архитекторы — Р. Р. Кликс, В. М. Таушканов. До 1959 года — \"Сибирь\", в 1960–1963 годах — \"Сельское хозяйство РСФСР\", в 1964–1966 годах — \"Топливная промышленность\". Объект культурного наследия федерального значения.",
    "description_eng": "Since 2003, the exhibition and commercial centre of the Republic of Armenia has been operating in the pavilion, where themed evenings and national holidays are held. The pavilion houses the \"Ararat\" restaurant, a tasting room, and a shop of Armenian products. The pavilion was built in 1954, architects - R. R. Klix, V. M. Taushkanov. Until 1959 - \"Sibir\", in 1960-1963 - \"Selskoe hozaystvo RSFSR\", in 1964-1966 - \"Toplivnaya promyshlennost\". An object of cultural heritage of federal significance.",
    "category": "Павильоны и сооружения",
    "width": "3.8",
    "height": "3",
    "left": "76.1",
    "top": "31.7",
    "borderRadius": "47",
    "transform": "-5",
    "transformImage": "5",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "2",
    "marginLeft": "0",
    "media": {
      "width": "2.9",
      "height": "2.3",
      "left": "56",
      "top": "23.35",
      "borderRadius": "38",
      "transform": "-23",
      "transformImage": "23",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "2",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №68. Выставочно-торговый центр Республики Армения.jpg`,
    "id": 46
  },
  {
    "name": "Музей «Атом»",
    "name_eng": "Museum «Atom»",
    "description": "Павильон «АТОМ» — это выставочный просветительский комплекс с крупнейшей и самой современной в России экспозицией, посвящённой ядерной энергии. Его общая площадь составляет более 25 тысяч квадратных метров, а вместимость — более 2 тысяч человек одновременно.",
    "description_eng": "The «ATOM» museum is an exhibition educational complex with the largest and most modern exposition in Russia dedicated to nuclear energy.Its total area is more than 25 thousand square meters, and the capacity is more than 2 thousand people at the same time.",
    "category": "Павильоны и сооружения",
    "mapIcon": "/mapElements/atom.png",
    "class": "element8",
    "elementInfoClass": "element-info-8",
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №19. «Атом».jpeg`,
    "id": 47
  },
  {
    "name": "Храм-часовня Святого Василия Великого",
    "name_eng": "Saint Basil the Great chapel",
    "description": "В храме-часовне, расположенном на территории сирингария в тихом и уединенном месте, проводятся регулярные службы, все желающие могут исповедоваться, креститься, венчаться. Святой Василий Великий, имя которого носит храм-часовня, жил в IV веке н. э., а свое имя — \"Великий\" — стал носить еще при жизни, так как был \"ученым в двенадцати науках\". При освящении часовни Патриарх Алексий II пояснил, что ВДНХ всегда славила все новое, передовое, как в науке, так и в народном хозяйстве, поэтому святой Василий Великий будет помогать коллективу Выставки в продолжении этого пути. Храм был построен в 2001 году на пожертвования сотрудников и гостей Выставки, а в 2011 году был реконструирован — к нему была пристроена алтарная часть. Храм-часовня приписан к храму Тихвинской иконы Божией Матери.",
    "description_eng": "The chapel temple, located in a quiet and secluded place on the territory of the syringarium, holds regular services, and everyone can confess, be baptised and married. Saint Basil the Great, whose name the chapel bears, lived in the 4th century A.D., and his name - \"the Great\" - began to be worn during his lifetime, as he was \"a scholar in the twelve sciences\". At the consecration of the chapel, Patriarch Alexy II explained that VDNH has always glorified everything new and advanced, both in science and in the national economy, so Saint Basil the Great will help the staff of the Exhibition to continue on this path. The temple was built in 2001 with donations from the Exhibition's employees and guests, and in 2011 it was reconstructed with the addition of an altar part. The chapel is attached to the Church of the Tikhvin Icon of the Mother of God.",
    "category": "Павильоны и сооружения",
    "width": "2.4",
    "height": "3.2",
    "left": "9.2",
    "top": "12.1",
    "borderRadius": "28",
    "transform": "0",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "1",
    "marginLeft": "0",
    "media": {
      "width": "2",
      "height": "2.3",
      "left": "6.7",
      "top": "9",
      "borderRadius": "44",
      "transform": "0",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "1",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Храм-часовня Святого Василия Великого.jpg`,
    "id": 51,
    "cantTeleportation": true
  },
  {
    "name": "Зелёный театр",
    "name_eng": "Green theatre",
    "description": "Зеленый театр ВДНХ — легендарная площадка, место притяжения меломанов и театралов. Здесь, на сцене под открытым небом, представлен разнообразный репертуар: от симфонических концертов и балета до выступлений современных рок-музыкантов. Зеленый театр появился на ВДНХ в 1939 году. В 1954 году театр был реконструирован по проекту московского архитектора Бориса Ефимовича. С самого начала своей истории он неизбежно должен был стать одной из самых легендарных площадок столицы, по праву являясь излюбленным местом выступлений известных коллективов и артистов оперной сцены и советской эстрады. Объект культурного наследия федерального значения.",
    "description_eng": "The Green Theatre of VDNH is a legendary venue, a place of attraction for music lovers and theatregoers. Here, on the open-air stage, a diverse repertoire is presented: from symphony concerts and ballet to performances by modern rock musicians. The Green Theatre appeared at VDNH in 1939. In 1954 the theatre was reconstructed according to the project of Moscow architect Boris Efimovich. From the very beginning of its history it was inevitably to become one of the most legendary venues of the capital, rightfully being a favourite place for performances of famous groups and artists of the opera stage and Soviet variety. An object of cultural heritage of federal significance.",
    "category": "Павильоны и сооружения",
    "width": "",
    "height": "",
    "left": "",
    "top": "",
    "borderRadius": "100",
    "transform": "",
    "media": {
      "width": "",
      "height": "",
      "left": "",
      "top": "",
      "borderRadius": "100",
      "transform": ""
    },
    "hidden": true,
    "imgUrl": `${appConfig.staticDomain}/file/Зеленый театр.jpg`,
    "id": 52
  },
  {
    "name": "Павильон №62. Международный центр балета",
    "name_eng": "Pavilion №62. International ballet centre",
    "description": "Международный центр балета — образовательная площадка, где проходят мастер-классы, лекции по истории балета, но прежде всего это балетная школа, где и дети, и взрослые исполняют свою мечту — учатся танцевать. Центр ориентирован на обучение не только классическому балету, но и народному танцу и джаз-модерну, также в нем проходят лекции, выступления и мастер-классы знаменитых хореографов из России и других стран. Эти направления входят в классическую программу подготовки артистов балета в хореографических училищах и академиях. Для тех, кто хочет посещать сразу несколько направлений, разработаны специальные абонементы. Такая программа позволяет наиболее полно раскрыть индивидуальные способности учеников, ведь у каждого вида танца существуют музыкальные, ритмические и хореографические особенности. Павильон построен в 1954 году. Архитекторы Г. И. Луцкий, Л. И. Лоповок. С 1954 года — \"Строительные материалы\". С 1956 года — \"Атомная энергия\". С 1959 года — \"Атомная энергия в мирных целях\". С 1964 года — \"Легкая промышленность\". С 1966 года — \"Охрана природы\". Объект культурного наследия федерального значения.",
    "description_eng": "The International ballet centre is an educational platform where master classes and lectures on the history of ballet take place, but above all it is a ballet school where both children and adults fulfil their dream of learning to dance. The centre focuses on training not only in classical ballet, but also in folk dance and jazz-modern, and it also hosts lectures, performances and master classes by famous choreographers from Russia and other countries. These areas are part of the classical training programme for ballet dancers at choreographic schools and academies. For those who want to attend several directions at once, special subscriptions have been developed. Such a programme allows the students to develop their individual abilities to the fullest, as each type of dance has musical, rhythmic and choreographic peculiarities. The pavilion was built in 1954. Architects G. I. Lutsky, L. I. Lopovok. Since 1954 - \"Stroitelnye materialy\". Since 1956 - \"Atomnaya energiya\". Since 1959 - \"Atomnaya energiya v mirnyh celyah\". Since 1964 - \"Legkaya promyshlennost\". Since 1966 - \"Ohrana prirody\". An object of cultural heritage of federal significance.",
    "category": "Павильоны и сооружения",
    "width": "3.7",
    "height": "2.5",
    "left": "50.3",
    "top": "14.1",
    "borderRadius": "51",
    "transform": "-15",
    "transformImage": "15",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "2",
    "marginLeft": "0",
    "media": {
      "width": "2.8",
      "height": "1.8",
      "left": "37",
      "top": "10.5",
      "borderRadius": "51",
      "transform": "-15",
      "transformImage": "15",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "2",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №62. Международный центр балета.jpg`,
    "id": 55
  },
  {
    "name": "Павильон №11. Выставочно-торговый центр Республики Казахстан",
    "name_eng": "Pavilion №11. Exhibition and trade centre of the Republic of Kazakhstan",
    "description": "Гости павильона №11 \"Казахстан\" могут увидеть уникальные экспонаты казахской культуры, мультимедийные экспозиции о становлении государственности Республики Казахстан, ознакомиться с достижениями народного хозяйства и промышленности, узнать о выдающихся казахских деятелях культуры, искусства и политики. В рамках ознакомительных экскурсий сотрудники павильона расскажут о национальных традициях и истории страны. Вниманию посетителей представлены масштабные экспозиционные макеты \"Шелковый путь\", \"Нур-Султан\", \"Стратегия развития\". Гости павильона могут отправиться в увлекательное мультимедийное путешествие по казахской культуре, традициям и узнать о современных достижениях страны. Павильон построен в 1954 году, архитекторы — И. М. Петров, Н. В. Куприянов, при участии Т. К. Басенова. Архитектурный облик павильона №11 Республики Казахстан отражает мотивы казахского национального зодчества. Главный фасад оформлен в виде трехпролетной арки и украшен барельефами с этническими орнаментами, а также скульптурами колхозницы и сталевара и памятниками поэту Джамбулу Джабаеву и передовику сельскохозяйственного производства Чиганаку Берсиеву. До 1964 года — \"Казахская ССР\", с 1964 года — \"Металлургия\". Объект культурного наследия федерального значения.",
    "description_eng": "Guests of Pavilion №11 \"Kazakhstan\" can see unique exhibits of Kazakh culture, multimedia expositions about the formation of statehood of the Republic of Kazakhstan, learn about the achievements of the national economy and industry, learn about outstanding Kazakh cultural, artistic and political figures. Within the framework of familiarisation tours the pavilion staff will tell about national traditions and history of the country. Large-scale exposition models \"Shelkovy put\", \"Nur-Sultan\", \"Strategiya razvitiya\" are presented to the visitors' attention. Guests of the pavilion can go on a fascinating multimedia journey through Kazakh culture, traditions and learn about the modern achievements of the country. The pavilion was built in 1954, architects - I. M. Petrov, N. V. Kupriyanov, with the participation of T. K. Basenov. Architectural appearance of the pavilion №11 of the Republic of Kazakhstan reflects the motifs of Kazakh national architecture. The main facade is designed in the form of a three-bay arch and decorated with bas-reliefs with ethnic ornaments, as well as sculptures of a collective farmer and a steelworker and monuments to the poet Dzhambul Dzhabaev and the foremost agricultural worker Chiganak Bersiev. Until 1964 - \"Kazakhskaya SSR\", since 1964 - \"Metallurgiya\". An object of cultural heritage of federal significance.",
    "category": "Павильоны и сооружения",
    "width": "4.4",
    "height": "3",
    "left": "59",
    "top": "34.5",
    "borderRadius": "44",
    "transform": "-18",
    "transformImage": "18",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "2",
    "marginLeft": "1",
    "media": {
      "width": "3",
      "height": "2.3",
      "left": "43.6",
      "top": "25.45",
      "borderRadius": "44",
      "transform": "-15",
      "transformImage": "15",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "2",
      "marginLeft": "1"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №11. Выставочно-торговый центр Республики Казахстан.jpg`,
    "id": 59
  },
  {
    "name": "Павильон №10. Выставочно-торговый центр Республики Молдова",
    "name_eng": "Pavilion №10. Exhibition and trade centre of the Republic of Moldova",
    "description": "Строительство павильона было окончено в декабре 1951 г., а в следующем декабре завершилось и внутреннее оформление, архитекторы — Ф. П. Наумов, А. И. Захаров, В. П. Туканов, при участии Е. В. Васильева. Главный фасад павильона, обращенный на площадь Дружбы Народов, украшен десятью барельефами основных отраслей сельского хозяйства и гербом республики, в котором присутствуют традиционные для Молдавской ССР виноград, кукуруза и пшеница, солнечные лучи и подсолнух. В павильоне открыт магазин товаров для здоровья, одежды, а также ресторан европейской и национальной кухни \"Leon\". Возможно проведение мероприятий, банкетов. Имеются площадки для организации форумов и конгрессов. До 1963 года — \"Молдавская ССР\", затем — \"Стандарты\" (после перехода ВДНХ на отраслевой принцип).",
    "description_eng": "The construction of the pavilion was finished in December 1951, and in the following December the interior decoration was completed, architects - F. P. Naumov, A. I. Zakharov, V. P. Tukanov, with the participation of E. V. Vasiliev. The main facade of the pavilion, facing the Nations Friendship Square, is decorated with ten bas-reliefs of the main branches of agriculture and the coat of arms of the Republic, which includes grapes, corn and wheat, sun rays and sunflower, traditional for the Moldavian SSR. In the pavilion there is a shop of goods for health, clothes, as well as a restaurant of European and national cuisine \"Leon\". It is possible to hold events and banquets. There are platforms for organising forums and congresses. Until 1963 - \"Moldavskaya SSR\", then - \"Standarty\" (after VDNH switched to the branch principle).",
    "category": "Павильоны и сооружения",
    "width": "3.9",
    "height": "2.8",
    "left": "62",
    "top": "36.3",
    "borderRadius": "44",
    "transform": "-5",
    "transformImage": "5",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "2",
    "marginLeft": "0",
    "media": {
      "width": "2.9",
      "height": "2",
      "left": "45.7",
      "top": "26.8",
      "borderRadius": "44",
      "transform": "-5",
      "transformImage": "5",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "2",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №10. Выставочно-торговый центр Республики Молдова.jpg`,
    "id": 60
  },
  {
    "name": "Павильон \"Умный город\"",
    "name_eng": "Pavilion \"Smart city\"",
    "description": "Павильон «Умный город» — это яркая мультимедийная выставка технологий Москвы. Здесь можно узнать, как искусственный интеллект справляется с управлением дорожным трафиком Москвы, какие технологии помогают водителям общественного транспорта и обеспечивают безопасность пассажиров.",
    "description_eng": "The Pavilion «Smart City» is a bright multimedia exhibition of Moscow technology.Here you can find out how artificial intelligence copes with the traffic management of Moscow, which technologies help drivers of public transport and ensure the safety of passengers.",
    "category": "Павильоны и сооружения",
    "mapIcon": "/mapElements/city.png",
    "class": "element12",
    "elementInfoClass": "element-info-12",
    "imgUrl": `${appConfig.staticDomain}/file/Павильон «Умный город».jpg`,
    "id": 61
  },
  {
    "name": "Павильон «Умные финансы»",
    "name_eng": "Pavilion «Smart Finance»",
    "description": "В павильоне № 71 «Умные финансы» выставки \"Россия\"  представлена экспозиция Центрального банка Российской Федерации. Посетителям рассказывают о прошлом, настоящем и будущем российского рынка банковских услуг.\n Посетители «Умных финансов» могут заглянуть в будущее и представить, как инновации изменят нашу жизнь, а также ознакомиться со всеми способами безналичной оплаты. В павильоне представлены современные финансовые технологии: от биометрии до искусственного интеллекта.",
    "description_eng": "In Pavilion No. 71 “Smart Finance” of the exhibition “Russia” is the exposition of the Central Bank of the Russian Federation.Visitors are told about the past, present and future of the Russian banking services market. \n Visitors to Smart Finance can look into the future and imagine how innovations will change our lives, as well as get acquainted with all the methods of non -cash payment.The pavilion presents modern financial technologies: from biometry to artificial intelligence.",
    "category": "Павильоны и сооружения",
    "mapIcon": "/mapElements/smart_finance.png",
    "class": "element6",
    "elementInfoClass": "element-info-6",
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №71. Дворец госуслуг (МФЦ).jpg`,
    "id": 62
  },
  {
    "name": "Павильон №8 \"Юные натуралисты\"",
    "name_eng": "Pavilion №8 \"Junye naturalisty\"",
    "description": "Музейный зал павильона \"Юные натуралисты\" — большое музейное пространство, объединяющее в себе тематические и интерактивные витрины, современные инсталляции и создающее интересное путешествие по музею для посетителей любых возрастов. Музейное пространство стало площадкой современного искусства, в котором есть место истории и творчеству, образам и впечатлениям. Также гости могут познакомиться здесь с кондитерскими профессиями и попробовать себя в этой роли. Построен в 1954 году. Архитекторы — Н. А. Гришин, Д. С. Витухин, А. С. Гольдин, Л. К. Игнатова, В. Г. Макаревич, А. Т. Полянский. Объект культурного наследия федерального значения.",
    "description_eng": "The museum hall of the \"Junye naturalisty\" pavilion is a large museum space that combines thematic and interactive showcases, modern installations and creates an interesting journey through the museum for visitors of all ages. The museum space has become a platform for contemporary art, where history and creativity, images and impressions have a place. Guests can also learn about confectionery professions here and try themselves in this role. It was built in 1954. Architects - N. A. Grishin, D. S. Vitukhin, A. S. Goldin, L. K. Ignatova, V. G. Makarevich, A. T. Polyansky. An object of cultural heritage of federal significance.",
    "category": "Павильоны и сооружения",
    "width": "3.6",
    "height": "2.8",
    "left": "52.9",
    "top": "40.7",
    "borderRadius": "35",
    "transform": "-35",
    "transformImage": "35",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "2",
    "marginLeft": "1",
    "media": {
      "width": "2.8",
      "height": "1.9",
      "left": "38.9",
      "top": "30.2",
      "borderRadius": "35",
      "transform": "-25",
      "transformImage": "25",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "2",
      "marginLeft": "1"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №8. Юные натуралисты.jpg`,
    "id": 65
  },
  {
    "name": "Дворец бракосочетания",
    "name_eng": "Palace of marriage",
    "description": "Дворец бракосочетания на ВДНХ расположен в уникальном историческом здании 1939 года, стилизованном под особняк XVII века. Внутреннее пространство разделено на церемониальный зал, просторный холл, гостиные и две террасы. Здание построено по проекту архитектора Николая Джемсовича Колли. Впервые Дворец бракосочетания распахнул двери для приема заявлений о заключении брака 25 февраля 2014 года, а 12 апреля — через 46 дней — прошла первая торжественная церемония. И с тех пор желающих обменяться кольцами именно в этом Дворце становится все больше и больше, ведь главная выставка страны — идеальное место для свадьбы. Среди молодоженов стало традицией фотографироваться на фоне отлитой в бронзе скульптурной композиции «Счастливая семья», расположенной в сквере Юннатов. По легенде такая фотография приносит счастье в браке. Обряд венчания можно совершить в храме-часовне святого Василия Великого, который также располагается на ВДНХ, на территории сирингария.",
    "description_eng": "The Marriage Palace at VDNH is located in a unique historical building dating back to 1939, stylised as a 17th century mansion. The interior space is divided into a ceremonial hall, a spacious lobby, living rooms and two terraces. The building was designed by the architect Nikolai Djemsovich Kolli. For the first time the Marriage Palace opened its doors to accept applications for marriage on 25 February 2014, and on 12 April - 46 days later - the first solemn ceremony took place. And since then, there are more and more people who want to get married in this Palace, as the country's main exhibition is an ideal place for a wedding. It has become a tradition among newlyweds to take photos against the background of the bronze sculptural composition \"Happy family\" located in the Yunnatov Square. According to legend, such a photo brings happiness in marriage. The wedding ceremony can be performed in the chapel of Saint Basil the Great, which is also located at VDNH, on the territory of the syringarium.",
    "category": "Павильоны и сооружения",
    "width": "3",
    "height": "2.2",
    "left": "47.1",
    "top": "12",
    "borderRadius": "44",
    "transform": "-8",
    "transformImage": "8",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "2",
    "marginLeft": "",
    "media": {
      "width": "2.4",
      "height": "1.8",
      "left": "34.7",
      "top": "8.8",
      "borderRadius": "44",
      "transform": "-31",
      "transformImage": "31",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "2",
      "marginLeft": "1"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Дворец бракосочетания.jpg`,
    "id": 67
  },
  {
    "name": "Павильон №66. Выставочно-культурный и экспозиционный центр Республики Узбекистан",
    "name_eng": "Pavilion №66. Exhibition, Cultural and exposition centre of the Republic of Uzbekistan",
    "description": "Павильон в стиле сталинского ампира с мотивами узбекского национального зодчества. Главным звеном в облике павильона является ротонда — великолепная стальная сень над фонтаном, струи которого вздымаются на высоту 15 метров. Основной художественный элемент оформления павильона — мотив хлопковой коробочки. Он вплетен в композиции карнизов, капителей, панно и других деталей здания. Таким образом создатели павильона отразили первенство Узбекской ССР в производстве хлопка. Первоначально его экспозиция была посвящена хлопководству, поэтому гостя встречал здесь стенд в виде огромного хлопкового поля, словно выросшего под \"солнцем\" ажурного, украшенного орнаментом купола. Продолжением экспозиции в прежние годы служили расположенные позади павильона магазин \"Узбеквино\" и ресторан \"Узбекская чайхана\", построенные к открытию ВСХВ 1954 года по проекту С. Н. Полупанова. Павильон построен в 1954 году, архитектор — С. Н. Полупанов. До 1964 года именовался \"Узбекская ССР\". Объект культурного наследия федерального значения.",
    "description_eng": "The pavilion is in the Stalin Empire style with motifs of Uzbek national architecture. The main link in the appearance of the pavilion is the rotunda - a magnificent steel canopy over the fountain, the jets of which soar to a height of 15 metres. The main artistic element of the pavilion's design is the cotton box motif. It is woven into the compositions of cornices, capitals, panels and other details of the building. In this way, the creators of the pavilion reflected the primacy of the Uzbek SSR in cotton production. Initially, its exposition was devoted to cotton growing, so the guest was greeted by a stand in the form of a huge cotton field, as if grown under the \"sun\" of an openwork dome decorated with ornaments. The exposition was continued by the \"Uzbekvino\" shop and \"Uzbekskaya chayhana\" restaurant located behind the pavilion, built for the opening of the All-Union Agricultural Exhibition in 1954 according to the project of S. N. Polupanov. The pavilion was built in 1954, architect - S. N. Polupanov. Until 1964 it was called \"Uzbekskaya SSR\". An object of cultural heritage of federal significance.",
    "category": "Павильоны и сооружения",
    "width": "5.2",
    "height": "3.5",
    "left": "66.5",
    "top": "29.2",
    "borderRadius": "40",
    "transform": "26",
    "transformImage": "-26",
    "marginTop": "0",
    "marginRight": "1",
    "marginBot": "2",
    "marginLeft": "0",
    "media": {
      "width": "4",
      "height": "2.5",
      "left": "49",
      "top": "21.5",
      "borderRadius": "40",
      "transform": "26",
      "transformImage": "-26",
      "marginTop": "0",
      "marginRight": "1",
      "marginBot": "2",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №66. Выставочно-культурный и экспозиционный центр Республики Узбекистан.jpg`,
    "id": 68
  },
  {
    "name": "Медиашкола Ольги Спиркиной Ostankino.tv",
    "name_eng": "Olga Spirkina's media school Ostankino.tv",
    "description": "Медиашкола Ольги Спиркиной Ostankino.tv — одна из самых известных организаций дополнительного образования в медиасфере, в области культуры речи, общения и грамотности. За более чем 15 лет обучение в школе прошли многие известные деятели телевидения, кино, представители бизнеса и политики. Среди преподавателей — журналисты, актеры, имиджмейкеры, имеющие многолетний практический опыт в теле- и киноиндустрии. Медиашкола Ольги Спиркиной Ostankino.tv участвует в крупнейшем оздоровительном, образовательном и досуговом проекте правительства Москвы \"Московское долголетие\", активно сотрудничает с \"Российским движением школьников\", с благотворительным фондом \"7 профессий\", который поддерживает детей из детских домов и малообеспеченных семей.",
    "description_eng": "Olga Spirkina's media school Ostankino.tv is one of the most famous organisations of additional education in the media sphere, in the field of speech culture, communication and literacy. For more than 15 years, the school has trained many famous TV and cinema personalities, business and political representatives. Among the teachers are journalists, actors, image-makers who have many years of practical experience in the TV and film industry. Olga Spirkina's media school Ostankino.tv participates in the largest health improvement, educational and leisure project of the Moscow government \"Moskovskoe dolgoletie\", actively cooperates with the \"Rossiyskim dvizheniem shkolnikov\" and the charity foundation \"7 professiy\", which supports children from orphanages and low-income families.",
    "category": "Павильоны и сооружения",
    "width": "3.5",
    "height": "2.6",
    "left": "70.45",
    "top": "17.35",
    "borderRadius": "42",
    "transform": "28",
    "transformImage": "-28",
    "marginTop": "0",
    "marginRight": "1",
    "marginBot": "2",
    "marginLeft": "0",
    "media": {
      "width": "2.5",
      "height": "1.6",
      "left": "51.9",
      "top": "12.8",
      "borderRadius": "32",
      "transform": "28",
      "transformImage": "-28",
      "marginTop": "0",
      "marginRight": "1",
      "marginBot": "2",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Медиа школа Ольги Спиркиной Ostankino.tv.jpeg`,
    "id": 69,
    "cantTeleportation": true
  },
  {
    "name": "Павильон №33",
    "name_eng": "Pavilion №33",
    "description": "Павильон строился для проведения машиностроительных выставок, которые регулярно проходили на ВДНХ СССР. В павильоне демонстрировались новейшие достижения советского автопрома и его отраслевая продукция. Павильон построен в 1967 году по проекту Проектного института №1 Госстроя СССР. С 1967 года — \"Автомобильная промышленность\".",
    "description_eng": "The pavilion was built for machine-building exhibitions, which were regularly held at VDNH of the USSR. The pavilion demonstrated the latest achievements of the Soviet automotive industry and its sectoral products. The pavilion was built in 1967 according to the project of the Design Institute №1 of the USSR State Construction Committee. Since 1967 - \"Avtomobilnaya promyshlennost\".",
    "category": "Павильоны и сооружения",
    "width": "",
    "height": "",
    "left": "",
    "top": "",
    "borderRadius": "100",
    "transform": "",
    "media": {
      "width": "",
      "height": "",
      "left": "",
      "top": "",
      "borderRadius": "100",
      "transform": ""
    },
    "hidden": true,
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №33.jpg`,
    "id": 71
  },
  {
    "name": "Павильон №15. Музей Олимпийского движения России",
    "name_eng": "Pavilion №15. Museum of the Russian Olympic movement",
    "description": "Павильон построен в 1954 году. Основными темами в оформлении главного фасада и интерьеров стали героика разгрома немецко-фашистских войск в годы Великой Отечественной войны и возрождение сельского хозяйства. После проведения ремонтно-реставрационных работ в павильоне откроется музей Олимпийского комитета России. Построен в 1954 году по проекту Е. В. Яковлева, И. М. Шошенского. До 1959 года — павильон Поволжья с восемью экспозиционными залами: вводный зал, зал Мордовской и Чувашской АССР, залы Сталинградской, Саратовской, Куйбышевской, Ульяновской, Астраханской областей; позднее — \"Радиоэлектроника и связь\". Объект культурного наследия федерального значения.",
    "description_eng": "The pavilion was built in 1954. The main themes in the design of the main facade and interiors are the heroics of the defeat of Nazi troops during the Great Patriotic War and the revival of agriculture. After renovation and restoration works, the pavilion will house the Museum of the Russian Olympic committee. It was built in 1954 according to the project of E. V. Yakovlev and I. M. Shoshensky. Until 1959 it was the pavilion of the Volga region with eight exposition halls: the introductory hall, the hall of the Mordovian and Chuvash ASSR, the halls of the Stalingrad, Saratov, Kuibyshev, Ulyanovsk and Astrakhan regions; later - \"Radioelektronika i svyaz\". An object of cultural heritage of federal significance.",
    "category": "Павильоны и сооружения",
    "width": "4.3",
    "height": "3.1",
    "left": "48.18",
    "top": " 28.2",
    "borderRadius": "44",
    "transform": "-20",
    "transformImage": "20",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "2",
    "marginLeft": "1",
    "media": {
      "width": "3.3",
      "height": "2.3",
      "left": "35.48",
      "top": "20.8",
      "borderRadius": "44",
      "transform": "-20",
      "transformImage": "20",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "2",
      "marginLeft": "1"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №15. Музей Олимпийского движения России.jpg`,
    "id": 74
  },
  {
    "name": "Павильон «ВЭБ.РФ»",
    "name_eng": "Pavilion «VEB RF»",
    "description": "Государственная корпорация ВЭБ.РФ обустроила экспозицию под названием «Города для жизни сбываются» в павильоне № 59 ВДНХ и включила в её состав разнообразный набор экспонатов и технических решений, которые заинтересуют посетителей самых разных возрастов и наглядно покажут им, как сильно изменилась жизнь в российских городах за последнее двадцатилетие.",
    "description_eng": "The VEB.rf state corporation equipped an exposition called “Cities for life” in Pavilion No. 59 VDNH and included a diverse set of exhibits and technical solutions that will interest visitors of various ages and clearly show them how much life has changed in Russian citiesOver the past twentieth anniversary.",
    "category": "Павильоны и сооружения",
    "mapIcon": "/mapElements/veb.png",
    "class": "element10",
    "elementInfoClass": "element-info-10",
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №59. Политехнический музей.jpg`,
    "id": 75
  },
  {
    "name": "Павильон №21",
    "name_eng": "Pavilion №21",
    "description": "По замечанию историка архитектуры А. Ю. Броновицкой, изогнутый козырек, нависающий над стеклянной стеной, — самый выразительный элемент главного фасада здания. Внимательные наблюдатели узнают в конструктиве принципы работы, которые популяризовал выдающийся французский зодчий ХХ века Ле Корбюзье. Примечательно, что подобное решение не имеет аналогов в архитектуре Выставки. Выставочный павильон №21 был построен к открытию ВСХВ в 1954 году по проекту архитектора А. К. Ростковского. В 1967 году павильон был перестроен по проекту, который разработали архитекторы Е. Анцута и В. Кузнецов. В 1954–1958 годах — \"Картофель и овощи\", в 1959–1963 годах — \"Сахарная и кондитерская промышленность\". С 1964 года — \"Газовая промышленность\".",
    "description_eng": "According to the architectural historian A. Y. Bronovitskaya, the curved canopy, overhanging the glass wall, is the most expressive element of the building's main facade. Attentive observers will recognise in the design the principles popularised by the outstanding French architect of the twentieth century, Le Corbusier. It is noteworthy that such a solution has no analogues in the architecture of the Exhibition. Exhibition pavilion №21 was built for the opening of the All-Union Agricultural Exhibition in 1954 according to the project of architect A. K. Rostkovsky. In 1967 the pavilion was rebuilt according to the project developed by architects E. Antsuta and V. Kuznetsov. In 1954-1958 - \"Kartofel i ovoshhi\", in 1959-1963 - \"Saharnaya i konditerskaya promyshlennost\". Since 1964 - \"Gazovaya promyshlennost\".",
    "category": "Павильоны и сооружения",
    "width": "5",
    "height": "4.3",
    "left": "23.8",
    "top": "25.5",
    "borderRadius": "66",
    "transform": "-3",
    "transformImage": "3",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "2",
    "marginLeft": "0",
    "media": {
      "width": "3.7",
      "height": "3.5",
      "left": "17.5",
      "top": "18.5",
      "borderRadius": "48",
      "transform": "17",
      "transformImage": "-17",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "2",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №21.jpg`,
    "id": 77
  },
  {
    "name": "Павильон «Дом полимеров Сибур»",
    "name_eng": "Pavilion \"House of Polymers Sibur\"",
    "description": "«Дом полимеров» — павильон компании «Сибур», российского лидера по производству синтетических материалов для строительства, транспорта, медицины, сельского хозяйства и других отраслей. Мы покажем и расскажем, как рождаются полимеры и где они применяются, почему над заводами иногда появляются облака, как правильно сортировать отходы и какие виды пластика существуют.",
    "description_eng": "The House of Polymers is the Pavilion of Siber, the Russian leader in the production of synthetic materials for the construction, transport, medicine, agriculture and other industries.We will show and tell how polymers are born and where they are used, why clouds sometimes appear over the plants, how to properly sort waste and what types of plastic exist.",
    "category": "Павильоны и сооружения",
    "mapIcon": "/mapElements/sibur.png",
    "class": "element7",
    "elementInfoClass": "element-info-7",
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №12.jpeg`,
    "id": 78
  },
  {
    "name": "Интерактивный музейный комплекс \"Буран\"",
    "name_eng": "Interactive museum complex \"Buran\"",
    "description": "Внутри макета орбитального корабля \"Буран БТС-001\" расположен интерактивный музей: здесь можно не только посмотреть фильм о легендарном ракетоплане, но и управлять его посадкой на космодроме Байконур в режиме реального времени. Оказавшись на борту ракетоплана, гости знакомятся с историей создания \"Бурана\". Кульминация экскурсии — посещение носовой части корабля, где в верхнем ярусе реконструирован командный отсек \"Бурана\" с приборной панелью и креслом космонавта. Его роль играет манекен в скафандре типа \"Стриж\". На нижнем ярусе носовой части корабля в роли пилотов космического челнока могут оказаться сами экскурсанты: здесь новоявленные летчики-испытатели получают уникальную возможность посадить \"Буран\" на космодром Байконур с высоты 80 000 метров. Программа полностью имитирует реальную посадку корабля 15 ноября 1988 года.",
    "description_eng": "Inside the mock-up of the \"Buran BTS-001\" orbiter there is an interactive museum: here you can not only watch a film about the legendary rocketplane, but also control its landing at the Baikonur Cosmodrome in real time. Once on board the rocketplane, the guests get acquainted with the history of \"Buran\" creation. The culmination of the excursion is a visit to the forward part of the ship, where in the upper tier reconstructed command compartment \"Buran\" with an instrument panel and a cosmonaut's chair. His role is played by a mannequin in a \"Strizh\" type spacesuit. On the lower tier of the forward part of the ship the excursionists themselves can play the role of the space shuttle pilots: here the new test pilots get a unique opportunity to land the \"Buran\" at the Baikonur Cosmodrome from a height of 80,000 metres. The programme fully simulates the real landing of the spacecraft on 15 November 1988.",
    "category": "Павильоны и сооружения",
    "width": "6.4",
    "height": "5.9",
    "left": "33.3",
    "top": "24.5",
    "borderRadius": "28",
    "transform": "56",
    "transformImage": "-56",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "2",
    "marginLeft": "-1.5",
    "media": {
      "width": "4.8",
      "height": "4.3",
      "left": "24.6",
      "top": "18.3",
      "borderRadius": "28",
      "transform": "-24",
      "transformImage": "24",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "2",
      "marginLeft": "1.5"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Интерактивный музейный комплекс «Буран».jpg`,
    "id": 81
  },
  {
    "name": "Павильон №13. Музей Востока",
    "name_eng": "Pavilion №13. Oriental Museum",
    "description": "В Музее Востока на ВДНХ представлены коллекции из фондов музея и экспозиция \"Музей Рерихов на ВДНХ. Ковчег будущего\". В экспозиции из фондов музея демонстрируется более 1500 экспонатов, основная часть которых ранее не выставлялась. Экспонируются предметы искусства Кавказа и Средней Азии, Дальнего Востока, Юго-Восточной Азии, Ближнего и Среднего Востока, Центральной Азии и Африки. В экспозиции \"Музей Рерихов на ВДНХ. Ковчег будущего\" представлено около 380 музейных предметов. Это живописные полотна Николая и Святослава Рерихов, копии архивных документов, произведения декоративно-прикладного искусства — металлическая скульптура и ритуальные предметы, древние бронзовые художественные изделия и украшения Индии, Тибета и Китая, собранные Рерихами в период экспедиций, а также предметы из других коллекций Государственного музея Востока. Павильон построен в 1939 году. Архитекторы — К. С. Алабян, С. А. Сафарян. Реконструирован в 1962 году по проекту С. А. Сафаряна. До 1963 года — \"Армянская ССР\". В 1964–1966 годах — \"Пищевая промышленность\". С 1967 года — \"Здравоохранение\". Объект культурного наследия федерального значения.",
    "description_eng": "The Museum of Oriental Art at VDNH presents collections from the museum's holdings and the exposition \"Muzey Rerihov na VDNH. Kovcheg budushhego\". The exposition from the museum's funds displays more than 1500 exhibits, most of which have not been exhibited before. Art objects from the Caucasus and Central Asia, Far East, South-East Asia, Near and Middle East, Central Asia and Africa are exhibited. The exposition \"Muzey Rerihov na VDNH. Kovcheg budushhego\" presents about 380 museum items. These are paintings by Nicholas and Svyatoslav Roerichs, copies of archival documents, works of decorative and applied art - metal sculpture and ritual objects, ancient bronze artworks and jewellery from India, Tibet and China, collected by the Roerichs during their expeditions, as well as items from other collections of the State Museum of Oriental Art. The pavilion was built in 1939. Architects - K. S. Alabyan, S. A. Safaryan. It was reconstructed in 1962 according to the project of S. A. Safaryan. Until 1963 - \"Armyanskaya SSR\". In 1964-1966 - \"Pishhevaya promyshlennost\". Since 1967 - \"Zdravoohranenie\". An object of cultural heritage of federal significance.",
    "category": "Павильоны и сооружения",
    "width": "5.1",
    "height": "2.8",
    "left": "53",
    "top": "31.7",
    "borderRadius": "44",
    "transform": "-32",
    "transformImage": "32",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "1.5",
    "marginLeft": "1",
    "media": {
      "width": "3.6",
      "height": "2",
      "left": "39.3",
      "top": "23.3",
      "borderRadius": "44",
      "transform": "-31",
      "transformImage": "31",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "1.5",
      "marginLeft": "1"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №13. Музей Востока.jpg`,
    "id": 84
  },
  {
    "name": "Павильон №22. Скалолазный центр BigWall",
    "name_eng": "Pavilion №22. BigWall сlimbing сentre",
    "description": "Скалодром BigWall, в зависимости от его вида и структуры, частично или полностью имитирует рельеф скалы. Большой, светлый и просторный павильон — это целый мир, выполненный по индивидуальным и новейшим технологиям для любителей и профессиональных спортсменов, для совсем юных и опытных людей. Bigwallsport — это настоящее городское скалолазание, пространство уникального личного опыта и комфортная среда для общения между гостями скалодрома. Для посетителей открыт просторный зал, окруженный панорамными окнами. В 13-метровом стенде для лазания на трудность есть зона с имитацией настоящей скалы, которая позволит вам почувствовать себя настоящим скалолазом. Также есть 9-метровые стенки с маршрутами разной сложности:опытный тренер поможет выбрать тот, который наиболее подойдет для физической подготовки каждого гостя. Все стенды оборудованы автостраховками для новичков и тех, кто пришел без напарника. Занятие на скалодроме — отличный способ провести время и попробовать что-то новое. Павильон построен в 1967 году на месте утраченного павильона \"Виноградарство\", архитекторы — Акопов, В. И. Жук при участии Пумпянской; инженер — А. М. Бройда. Изначально носил название \"Плодоовощеводство и картофелеводство\", а затем — \"Виноградарство и садоводство\" (экспозиция при переименованиях менялась лишь частично). В прежние времена в павильоне \"Плодоовощеводство\" велась работа по созданию разнообразных огородных культур.",
    "description_eng": "The BigWall climbing wall, depending on its type and structure, partially or completely imitates the relief of a rock. The large, bright and spacious pavilion is a whole world of individualised and state-of-the-art technology for amateurs and professional athletes, for the very young and experienced. Bigwallsport is a real urban climbing, a space of unique personal experience and a comfortable environment for communication between the guests of the climbing centre. A spacious hall surrounded by panoramic windows is open to visitors. The 13-metre difficulty climbing wall has an area with a real rock simulation that will make you feel like a real climber. There are also 9-metre walls with routes of varying difficulty: an experienced coach will help you choose the one that best suits the physical fitness of each guest. All the walls are equipped with auto-insurance for beginners and those who came without a partner. A session on the climbing wall is a great way to spend time and try something new. The pavilion was built in 1967 on the place of the lost pavilion \"Vinogradarstvo\", architects - Akopov, V. I. Zhuk with the participation of Pumpyanskaya; engineer - A. M. Broida. Initially it was called \"Plodoovoshhevodstvo i kartofelevodstvo\", and later - \"Vinogradarstvo i sadovodstvo\" (the exposition changed only partially during the renaming). In the past, the \"Plodoovoshhevodstvo\" pavilion was used to create a variety of horticultural crops.",
    "category": "Павильоны и сооружения",
    "width": "4.5",
    "height": "3.3",
    "left": "7.4",
    "top": "27.3",
    "borderRadius": "38",
    "transform": "-31",
    "transformImage": "31",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "2",
    "marginLeft": "1",
    "media": {
      "width": "3.5",
      "height": "2.3",
      "left": "5.4",
      "top": "20.3",
      "borderRadius": "29",
      "transform": "-31",
      "transformImage": "31",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "2",
      "marginLeft": "1"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Павильон №22. Скалолазный центр BigWall.jpg`,
    "id": 85,
    "cantTeleportation": true
  },
  {
    "name": "Кафе \"Вареничная №1\"",
    "name_eng": "Cafe \"Varenichnaya №1\"",
    "description": "\"Вареничная №1\" — идеальное место для похода всей семьей. В кафе три зала, один из которых оборудован детской комнатой, а по выходным здесь работает \"Детский клуб\", в котором проходят интересные мероприятия и кулинарные мастер-классы. Интерьер посвящен теме освоения космоса: здесь можно увидеть модели советских космических спутников и портреты Юрия Гагарина на стенах. Стеллажи с книгами, растения в горшках и разноцветные лампы создают необычайный уют и помогают вернуться в прекрасную атмосферу счастливого детства.",
    "description_eng": "\"Varenychnaya №1\" is an ideal place for a family outing. The café has three halls, one of which is equipped with a children's room, and on weekends there is a \"Children's club\", which hosts interesting events and cookery masterclasses. The interior is dedicated to the theme of space exploration: here you can see models of Soviet space satellites and portraits of Yuri Gagarin on the walls. Shelves with books, potted plants and multicoloured lamps create an extraordinary cosiness and help to return to the wonderful atmosphere of happy childhood.",
    "category": "Павильоны и сооружения",
    "width": "1.2",
    "height": "1.2",
    "left": "71.4",
    "top": "45.3",
    "borderRadius": "30",
    "transform": "-37",
    "transformImage": "37",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "1",
    "marginLeft": "1",
    "media": {
      "width": "0.9",
      "height": "0.9",
      "left": "52.7",
      "top": "33.4",
      "borderRadius": "21",
      "transform": "-40",
      "transformImage": "40",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "1",
      "marginLeft": "1"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Кафе Вареничная №1.jpg`,
    "id": 91
  },
  {
    "name": "Сквер юннатов",
    "name_eng": "Juniors' square",
    "description": "Расположен перед павильоном №8 \"Юные натуралисты\". Центром ландшафтной композиции сквера является прямоугольный цветник посреди площадки отдыха. По северо-восточной границе сквера высажен ряд голубых елей, по юго-западной границе, вдоль Кольцевой дороги — ряд стриженых елей.",
    "description_eng": "It is located in front of pavilion №8 \"Junye naturalisty\". The centre of the park's landscape composition is a rectangular flower bed in the middle of the recreation area. A row of blue spruce trees is planted along the north-eastern border of the park, and a row of sheared spruce trees along the south-western border, along the Ring Road.",
    "category": "Павильоны и сооружения",
    "width": "",
    "height": "",
    "left": "",
    "top": "",
    "borderRadius": "100",
    "transform": "",
    "media": {
      "width": "",
      "height": "",
      "left": "",
      "top": "",
      "borderRadius": "100",
      "transform": ""
    },
    "hidden": true,
    "imgUrl": `${appConfig.staticDomain}/file/Сквер юннатов.jpg`,
    "id": 92
  },
  {
    "name": "Кафе \"Андерсон на даче\"",
    "name_eng": "\"Anderson na dache\" cafe",
    "description": "\"АндерСон на даче\" — настоящее семейное кафе с разнообразными десертами: бельгийскими вафлями с кленовым сиропом, шоколадными тартами и баварезе с ягодами, миндальными кексами и безе, трюфелями и эклерами, пирожками, печеньем, круассанами, мармеладом и марципанами. Кроме сладкого, конечно же, есть и основное меню: на завтрак — сырники, омлеты и разнообразные каши, на обед можно заказать суп, салат или горячее, а на ужин — вареники, пасту домашней работы и многое другое. На втором этаже кафе есть просторная игровая комната с сухим бассейном, игрушками и аниматором — родители могут выдохнуть и спокойно пообедать, наблюдая за происходящим в детской на экранах, расположенных по всему кафе.",
    "description_eng": "\"AnderSon na dache\" is a real family cafe with various desserts: Belgian waffles with maple syrup, chocolate tarts and bavarese with berries, almond muffins and meringue, truffles and eclairs, pies, biscuits, croissants, marmalade and marzipan. In addition to sweets, of course, there is the main menu: for breakfast - cheesecakes, omelettes and a variety of porridge, for lunch you can order soup, salad or hot dish, and for dinner - dumplings, homemade pasta and much more. On the first floor of the cafe there is a spacious playroom with a dry pool, toys and an animator - parents can exhale and have a quiet lunch while watching what is happening in the nursery on screens located throughout the cafe.",
    "category": "Павильоны и сооружения",
    "width": "1.2",
    "height": "1.2",
    "left": "56.34",
    "top": "43.9",
    "borderRadius": "30",
    "transform": "-37",
    "transformImage": "37",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "1",
    "marginLeft": "1",
    "media": {
      "width": "0.9",
      "height": "0.9",
      "left": "41.6",
      "top": "32.34",
      "borderRadius": "16",
      "transform": "-39",
      "transformImage": "39",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "1",
      "marginLeft": "1"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Андерсон на даче.jpg`,
    "id": 93,
    "cantTeleportation": true
  },
  {
    "name": "Рязанский сквер",
    "name_eng": "Ryazansky square",
    "description": "Напротив Латвийского сквера, рядом с павильоном №17, располагается Рязанский сквер. Здесь проведены работы по благоустройству. Выполнено мощение из природного камня, установлены новые опоры освещения, устроены цветники и газоны.",
    "description_eng": "Opposite Latvia square, next to Pavilion №17, is Ryazansky square. Improvement works have been carried out here. Natural stone paving was made, new lighting poles were installed, flower beds and lawns were created.",
    "category": "Павильоны и сооружения",
    "width": "",
    "height": "",
    "left": "",
    "top": "",
    "borderRadius": "100",
    "transform": "",
    "media": {
      "width": "",
      "height": "",
      "left": "",
      "top": "",
      "borderRadius": "100",
      "transform": ""
    },
    "hidden": true,
    "imgUrl": `${appConfig.staticDomain}/file/Рязанский участок.jpg`,
    "id": 94
  },
  {
    "name": "Ресторан \"Московское небо\"",
    "name_eng": "\"Moskovskoe nebo\" restaurant",
    "description": "Меню ресторана \"Московское небо\" — это традиции 15 союзных республик, сплетенные воедино. При оформлении интерьера вдохновением служили образы отважных летчиков и грезы о небе — безграничном и окрыляющем. Два светлых зала декорированы тематическими фресками, сюжеты которых также ассоциативны с полетами.",
    "description_eng": "The menu of the \"Moskovskoe nebo\" restaurant is the traditions of 15 Soviet republics woven together. The interior design was inspired by images of brave pilots and dreams of the sky - boundless and exhilarating. Two bright halls are decorated with thematic murals, the subjects of which are also associated with flights.",
    "category": "Павильоны и сооружения",
    "width": "1.5",
    "height": "0.9",
    "left": "43.8",
    "top": "14.76",
    "borderRadius": "16",
    "transform": "-31",
    "transformImage": "31",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "1.5",
    "marginLeft": "1",
    "media": {
      "width": "1.2",
      "height": "0.8",
      "left": "32.3",
      "top": "10.8",
      "borderRadius": "16",
      "transform": "-31",
      "transformImage": "31",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "1.5",
      "marginLeft": "1"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Ресторан Московское небо.jpg`,
    "id": 96
  },
  {
    "name": "Летний кинотеатр-лекторий",
    "name_eng": "Summer cinema-lecture theatre",
    "description": "Летние вечера в кинотеатре — это свежий воздух, хорошие фильмы и приятная компания. Здесь нет ограничений в виде подлокотников кресел: можно удобно сесть, уютно укутаться в плед и насладиться особой атмосферой. Единый зал кинотеатра, напоминающий партер-амфитеатр, вмещает 288 гостей. Удобные сидения расположены ступенеобразно, что позволяет зрителям комфортно разместиться, не загораживая обзор друг другу. Рассадка \"в партере\" — свободная. Для комфортного просмотра фильмов есть подушки и пледы. На случай дождливой погоды над кинотеатром оборудована крыша в виде тента. Репертуар — новинки проката, фестивальное кино, классические кинохиты.",
    "description_eng": "Summer evenings at the cinema mean fresh air, good films and pleasant company. There are no restrictions in the form of armrests: you can sit down comfortably, wrap yourself in a plaid and enjoy the special atmosphere.The cinema's single auditorium, reminiscent of a parterre-amphitheatre, seats 288 guests. Comfortable seats are arranged in a step-like manner, which allows the audience to sit comfortably without blocking each other's view. Seating in the stalls is free. There are cushions and plaids for comfortable film watching. In case of rainy weather, the cinema has a roof in the form of an awning. The repertoire includes new releases, festival films and classic hits.",
    "category": "Павильоны и сооружения",
    "width": "2.3",
    "height": "1.5",
    "left": "51.4",
    "top": "11.76",
    "borderRadius": "27",
    "transform": "-30",
    "transformImage": "30",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "1.5",
    "marginLeft": "1",
    "media": {
      "width": "1.6",
      "height": "1.2",
      "left": "37.9",
      "top": "8.55",
      "borderRadius": "27",
      "transform": "-37",
      "transformImage": "37",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "1.5",
      "marginLeft": "1"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Кинотеатр-лекторий.jpg`,
    "id": 97,
    "cantTeleportation": true
  },
  {
    "name": "Дом бабочек",
    "name_eng": "House of butterflies",
    "description": "В строении 519 работает \"Баттерфляриум\" — выставка живых тропических бабочек и музей коллекций насекомых со всего мира. В галерее показывают фильмы о жизнедеятельности бабочек, их рождении, местах обитания и видах, проводятся тематические экскурсии и фотосессии. Павильон построен в 1954 году в стиле неоклассицизма. Фасады парных боковых объемов декорированы пилястрами с капителями стилизованного ионического ордена.",
    "description_eng": "Building 519 houses the \"Butterflyarium\", an exhibition of live tropical butterflies and a museum of insect collections from around the world. The gallery shows films about the life of butterflies, their birth, habitats and species, as well as thematic tours and photo shoots. The pavilion was built in 1954 in neoclassicism style. The facades of the paired side volumes are decorated with pilasters with capitals of stylised ionic order.",
    "category": "Павильоны и сооружения",
    "width": "3.5",
    "height": "2.6",
    "left": "64.55",
    "top": "23.35",
    "borderRadius": "42",
    "transform": "-23",
    "transformImage": "23",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "1.5",
    "marginLeft": "0",
    "media": {
      "width": "2.5",
      "height": "1.6",
      "left": "47.65",
      "top": "17.35",
      "borderRadius": "42",
      "transform": "-23",
      "transformImage": "23",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "1.5",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Дом бабочек.jpg`,
    "id": 98
  },
  {
    "name": "Четырнадцать магазинов Центральной аллеи",
    "name_eng": "Fourteen shops in Central alley",
    "description": "В магазинах представлен широкий выбор сувениров на любой вкус: красочные значки и магниты, яркие настенные тарелки, подарочные кружки, сладкие подарки с символикой ВДНХ. Гости могут приобрести здесь товары, которые помогут больше узнать о Выставке: книги по архитектуре и истории ВДНХ, путеводители с наиболее популярными маршрутами, туристические карты. Юным посетителям адресованы тематические раскраски. Особой популярностью помимо сувениров ВДНХ, пользуются товары с символикой Москвы и СССР. В ассортименте есть и необычные глиняные колокольчики и блюда, которые вручную делают люди с ограниченными физическими возможностями. Каждое такое изделие уникально. В случае непогоды в магазинах можно приобрести зонты и дождевики.",
    "description_eng": "The shops offer a wide range of souvenirs for every taste: colourful badges and magnets, bright wall plates, gift mugs, sweet gifts with VDNH symbols. Guests can buy goods that will help them learn more about the Exhibition: books on the architecture and history of VDNH, guidebooks with the most popular routes, tourist maps. Thematic colouring books are addressed to young visitors. In addition to VDNH souvenirs, goods with Moscow and USSR symbols are especially popular. The assortment also includes unusual clay bells and dishes that are handmade by people with disabilities. Each such product is unique. In case of bad weather, umbrellas and mackintoshes are available in the shops.",
    "category": "Павильоны и сооружения",
    "width": "",
    "height": "",
    "left": "",
    "top": "",
    "borderRadius": "100",
    "transform": "",
    "media": {
      "width": "",
      "height": "",
      "left": "",
      "top": "",
      "borderRadius": "100",
      "transform": ""
    },
    "hidden": true,
    "imgUrl": `${appConfig.staticDomain}/file/14Магазинов.png`,
    "id": 11111
  },
  {
    "name": "Проспект Мира, 119с471",
    "name_eng": "Prospekt Mira, 119c471",
    "description": "Подстанция",
    "description_eng": "Substation",
    "width": "1.2",
    "height": "1.2",
    "left": "54.6",
    "top": "36.7",
    "borderRadius": "30",
    "transform": "-37",
    "transformImage": "37",
    "marginTop": "0",
    "marginRight": "-1",
    "marginBot": "1.3",
    "marginLeft": "0",
    "media": {
      "width": "0.9",
      "height": "0.9",
      "left": "40.3",
      "top": "27.1",
      "borderRadius": "16",
      "transform": "-39",
      "transformImage": "39",
      "marginTop": "0",
      "marginRight": "-1",
      "marginBot": "1.3",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/119с471.jpg`,
    "id": "temp1"
  },
  {
    "name": "Проспект Мира, 119с515",
    "name_eng": "Prospekt Mira, 119c515",
    "description": "Проспект Мира, 119с515",
    "description_eng": "Prospekt Mira, 119c515",
    "width": "1.2",
    "height": "1.2",
    "left": "51.5",
    "top": "34.9",
    "borderRadius": "30",
    "transform": "-37",
    "transformImage": "37",
    "marginTop": "0",
    "marginRight": "-1",
    "marginBot": "1.3",
    "marginLeft": "0",
    "media": {
      "width": "0.9",
      "height": "0.8",
      "left": "38",
      "top": "25.7",
      "borderRadius": "16",
      "transform": "-39",
      "transformImage": "39",
      "marginTop": "0",
      "marginRight": "-1",
      "marginBot": "1.3",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/119с515.jpg`,
    "id": "temp2"
  },
  {
    "name": "Проспект Мира, 119с513",
    "name_eng": "Prospekt Mira, 119c513",
    "description": "Магазин",
    "description_eng": "Shop",
    "width": "1.2",
    "height": "1.2",
    "left": "50.4",
    "top": "34.1",
    "borderRadius": "30",
    "transform": "-37",
    "transformImage": "37",
    "marginTop": "0",
    "marginRight": "-1",
    "marginBot": "1.3",
    "marginLeft": "0",
    "media": {
      "width": "0.9",
      "height": "0.9",
      "left": "37.14",
      "top": "25.1",
      "borderRadius": "21",
      "transform": "-40",
      "transformImage": "40",
      "marginTop": "0",
      "marginRight": "-1",
      "marginBot": "1.3",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/119с513.jpg`,
    "id": "temp3"
  },
  {
    "name": "Проспект Мира, 119с531",
    "name_eng": "Prospekt Mira, 119c531",
    "description": "Шашлычная \"Владикавказ\"",
    "description_eng": "Shashlychnaya \"Vladikavkaz\"",
    "width": "1.2",
    "height": "1.2",
    "left": "49",
    "top": "33.3",
    "borderRadius": "30",
    "transform": "-37",
    "transformImage": "37",
    "marginTop": "0",
    "marginRight": "-1",
    "marginBot": "1.3",
    "marginLeft": "0",
    "media": {
      "width": "0.9",
      "height": "0.9",
      "left": "36.14",
      "top": "24.5",
      "borderRadius": "21",
      "transform": "-40",
      "transformImage": "40",
      "marginTop": "0",
      "marginRight": "-1",
      "marginBot": "1.3",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/119с531.jpg`,
    "id": "temp4"
  },
  {
    "name": "Проспект Мира, 119с529",
    "name_eng": "Prospekt Mira, 119c529",
    "description": "Кафе",
    "description_eng": "Cafe",
    "width": "1.2",
    "height": "1.7",
    "left": "45.14",
    "top": "30.7",
    "borderRadius": "30",
    "transform": "-52",
    "transformImage": "52",
    "marginTop": "0",
    "marginRight": "-1",
    "marginBot": "1",
    "marginLeft": "0",
    "media": {
      "width": "0.7",
      "height": "1.3",
      "left": "33.35",
      "top": "22.6",
      "borderRadius": "21",
      "transform": "-55",
      "transformImage": "55",
      "marginTop": "0",
      "marginRight": "-1",
      "marginBot": "1",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/119с529.jpg`,
    "id": "temp5"
  },
  {
    "name": "Проспект Мира, 119с525",
    "name_eng": "Prospekt Mira, 119c525",
    "description": "Кафе",
    "description_eng": "Cafe",
    "width": "1.2",
    "height": "1.7",
    "left": "44.1",
    "top": "31.4",
    "borderRadius": "30",
    "transform": "-52",
    "transformImage": "52",
    "marginTop": "0",
    "marginRight": "-1.2",
    "marginBot": "1",
    "marginLeft": "0",
    "media": {
      "width": "0.7",
      "height": "1.3",
      "left": "32.6",
      "top": "23.05",
      "borderRadius": "21",
      "transform": "-55",
      "transformImage": "55",
      "marginTop": "0",
      "marginRight": "-1.2",
      "marginBot": "1",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/119с525.jpg`,
    "id": "temp6"
  },
  {
    "name": "Проспект Мира, 119с356",
    "name_eng": "Prospekt Mira, 119c356",
    "description": "Техническое здание",
    "description_eng": "Technical building",
    "width": "1.2",
    "height": "1.2",
    "left": "40.6",
    "top": "28.4",
    "borderRadius": "30",
    "transform": "-42",
    "transformImage": "42",
    "marginTop": "0",
    "marginRight": "-1",
    "marginBot": "1.3",
    "marginLeft": "0",
    "media": {
      "width": "0.9",
      "height": "0.9",
      "left": "29.95",
      "top": "21",
      "borderRadius": "16",
      "transform": "-39",
      "transformImage": "39",
      "marginTop": "0",
      "marginRight": "-1",
      "marginBot": "1.3",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/119с356.jpg`,
    "id": "temp7"
  },
  {
    "name": "Проспект Мира, 119с582",
    "name_eng": "Prospekt Mira, 119c582",
    "description": "Подстанция",
    "description_eng": "Substation",
    "width": "1",
    "height": "1",
    "left": "40.8",
    "top": "14.9",
    "borderRadius": "100",
    "transform": "",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "1.5",
    "marginLeft": "0",
    "media": {
      "width": "0.7",
      "height": "0.6",
      "left": "30.17",
      "top": "11",
      "borderRadius": "100",
      "transform": "",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "1.5",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/119с582.jpg`,
    "id": "temp8"
  },
  {
    "name": "Проспект Мира, 119с345",
    "name_eng": "Prospekt Mira, 119c345",
    "description": "Техническое здание",
    "description_eng": "Technical building",
    "width": "1",
    "height": "1",
    "left": "39.9",
    "top": "14.2",
    "borderRadius": "100",
    "transform": "",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "1.5",
    "marginLeft": "0",
    "media": {
      "width": "0.7",
      "height": "0.6",
      "left": "29.47",
      "top": "10.52",
      "borderRadius": "100",
      "transform": "",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "1.5",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/119с345.jpg`,
    "id": "temp9"
  },
  {
    "name": "Проспект Мира, 119с506",
    "name_eng": "Prospekt Mira, 119c506",
    "description": "Проспект Мира, 119с506",
    "description_eng": "Prospekt Mira, 119c506",
    "width": "1",
    "height": "1",
    "left": "40.7",
    "top": "13.5",
    "borderRadius": "100",
    "transform": "",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "1.5",
    "marginLeft": "0",
    "media": {
      "width": "0.7",
      "height": "0.6",
      "left": "30.1",
      "top": "10.1",
      "borderRadius": "100",
      "transform": "",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "1.5",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/119с506.jpg`,
    "id": "temp10"
  },
  {
    "name": "Проспект Мира, 119с510",
    "name_eng": "Prospekt Mira, 119c510",
    "description": "Гастроном №1",
    "description_eng": "Gastronom №1",
    "width": "1.6",
    "height": "1.6",
    "left": "42.05",
    "top": "13.3",
    "borderRadius": "100",
    "transform": "",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "1.5",
    "marginLeft": "0",
    "media": {
      "width": "1.2",
      "height": "1.2",
      "left": "31",
      "top": "9.8",
      "borderRadius": "100",
      "transform": "",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "1.5",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/119с510.jpg`,
    "id": "temp11"
  },
  {
    "name": "Проспект Мира, 119с501",
    "name_eng": "Prospekt Mira, 119c501",
    "description": "Проспект Мира, 119с501",
    "description_eng": "Prospekt Mira, 119c501",
    "width": "",
    "height": "",
    "left": "",
    "top": "",
    "borderRadius": "100",
    "transform": "",
    "media": {
      "width": "",
      "height": "",
      "left": "",
      "top": "",
      "borderRadius": "100",
      "transform": ""
    },
    "hidden": true,
    "imgUrl": `${appConfig.staticDomain}/file/119с501.jpg`,
    "id": "temp12"
  },
  {
    "name": "Проспект Мира, 119с526",
    "name_eng": "Prospekt Mira, 119c526",
    "description": "Кафе \"Ласточка\"",
    "description_eng": "Cafe \"Lastochka\"",
    "width": "",
    "height": "",
    "left": "",
    "top": "",
    "borderRadius": "100",
    "transform": "",
    "media": {
      "width": "",
      "height": "",
      "left": "",
      "top": "",
      "borderRadius": "100",
      "transform": ""
    },
    "hidden": true,
    "imgUrl": `${appConfig.staticDomain}/file/119с526.png`,
    "id": "temp13"
  },
  {
    "name": "Проспект Мира, 119с137",
    "name_eng": "Prospekt Mira, 119c137",
    "description": "\"Детское посольство\" — это не просто частный детский сад, а экосистема, в которой ребенок развивается в соответствии со своей индивидуальностью. Волшебные домики детства (строения №475, 130, 134, 137, 163 и 290) расположены в удивительно живописном тихом месте, окруженном лесным массивом. Детей окружает особая дружеская атмосфера доброты, поддержки и творческой радости.",
    "description_eng": "\"Detskoe posolstvo\" is not just a private kindergarten, but an ecosystem where a child develops according to his or her individuality. The magical houses of childhood (buildings №475, 130, 134, 137, 163 and 290) are located in a wonderfully picturesque quiet place surrounded by a forest area. Children are surrounded by a special friendly atmosphere of kindness, support and creative joy.",
    "width": "2.1",
    "height": "1.7",
    "left": "12",
    "top": "27.2",
    "borderRadius": "44",
    "transform": "-32",
    "transformImage": "32",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "1.5",
    "marginLeft": "0.7",
    "media": {
      "width": "1.6",
      "height": "1.3",
      "left": "8.9",
      "top": "20",
      "borderRadius": "44",
      "transform": "-32",
      "transformImage": "32",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "1.5",
      "marginLeft": "0.7"
    },
    "imgUrl": `${appConfig.staticDomain}/file/119с137.jpg`,
    "id": "temp14"
  },
  {
    "name": "Проспект Мира, 119с130",
    "name_eng": "Prospekt Mira, 119c130",
    "description": "\"Детское посольство\" — это не просто частный детский сад, а экосистема, в которой ребенок развивается в соответствии со своей индивидуальностью. Волшебные домики детства (строения №475, 130, 134, 137, 163 и 290) расположены в удивительно живописном, тихом месте, окруженном лесным массивом. Детей окружает особая дружеская атмосфера доброты, поддержки и творческой радости.",
    "description_eng": "\"Detskoe posolstvo\" is not just a private kindergarten, but an ecosystem where a child develops according to his or her individuality. The magical houses of childhood (buildings №475, 130, 134, 137, 163 and 290) are located in a wonderfully picturesque quiet place surrounded by a forest area. Children are surrounded by a special friendly atmosphere of kindness, support and creative joy.",
    "width": "",
    "height": "",
    "left": "",
    "top": "",
    "borderRadius": "100",
    "transform": "",
    "media": {
      "width": "",
      "height": "",
      "left": "",
      "top": "",
      "borderRadius": "100",
      "transform": ""
    },
    "hidden": true,
    "imgUrl": `${appConfig.staticDomain}/file/119с130.jpg`,
    "id": "temp15"
  },
  {
    "name": "Проспект Мира, 119с577",
    "name_eng": "Prospekt Mira, 119c577",
    "description": "Трансформаторная подстанция",
    "description_eng": "Transformer substation",
    "width": "1.7",
    "height": "0.9",
    "left": "17.3",
    "top": "9.5",
    "borderRadius": "16",
    "transform": "-210",
    "transformImage": "210",
    "marginTop": "2",
    "marginRight": "0.5",
    "marginBot": "0",
    "marginLeft": "0",
    "media": {
      "width": "1.2",
      "height": "0.6",
      "left": "12.8",
      "top": "7",
      "borderRadius": "16",
      "transform": "-212",
      "transformImage": "212",
      "marginTop": "1.5",
      "marginRight": "0.5",
      "marginBot": "0",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/119с577.jpg`,
    "id": "temp16"
  },
  {
    "name": "Кафе \"Лето\"",
    "name_eng": "Cafe \"Leto\"",
    "description": "Это особенный павильон с по-настоящему летней атмосферой. Благодаря просторной открытой веранде и боковым галереям второго яруса его силуэт кажется легким и воздушным, даже несмотря на большую площадь. В настоящее время павильон закрыт на реставрацию.",
    "description_eng": "This is a special pavilion with a truly summer atmosphere. Thanks to the spacious open veranda and the side galleries of the second tier, its silhouette seems light and airy, even though it is large. The pavilion is currently closed for restoration.",
    "width": "",
    "height": "",
    "left": "",
    "top": "",
    "borderRadius": "100",
    "transform": "",
    "media": {
      "width": "",
      "height": "",
      "left": "",
      "top": "",
      "borderRadius": "100",
      "transform": ""
    },
    "hidden": true,
    "imgUrl": `${appConfig.staticDomain}/file/Кафе «Лето».jpg`,
    "id": "temp17"
  },
  {
    "name": "Ресторан \"Оттепель\"",
    "name_eng": "Restaurant \"Ottepel\"",
    "description": "Здание ресторана \"Оттепель\" — это не историческая реконструкция, а своего рода игра в ассоциации. Открытая кладка из кирпича, большие панорамные окна, монументальные колоннады центрального холла отдают дань истории павильона \"Шелководство\" 1956 года. А интерьер ресторана напоминает гостям о том периоде, оставаясь при этом стильным и актуальным.",
    "description_eng": "The building of the \"Ottepel\" restaurant is not a historical reconstruction, but a kind of a game of association. The open brickwork, large panoramic windows, monumental colonnades of the central hall pay tribute to the history of the \"Shelkovodstvo\" pavilion of 1956. And the restaurant's interior reminds guests of that period, while remaining stylish and up-to-date.",
    "width": "1.2",
    "height": "1.2",
    "left": "20.1",
    "top": "29.8",
    "borderRadius": "30",
    "transform": "-42",
    "transformImage": "42",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "1",
    "marginLeft": "1",
    "media": {
      "width": "0.8",
      "height": "0.9",
      "left": "14.9",
      "top": "22",
      "borderRadius": "16",
      "transform": "-125",
      "transformImage": "125",
      "marginTop": "1",
      "marginRight": "0",
      "marginBot": "0",
      "marginLeft": "1.3"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Ресторан «Оттепель».jpg`,
    "id": "temp18"
  },
  {
    "name": "Аллея Космонавтов (Каштановая роща)",
    "name_eng": "Cosmonauts Alley (Chestnut grove)",
    "description": "Аллея Космонавтов была заложена посадкой первого каштана космонавтом Павлом Беляевым в память о погибших коллегах и друзьях Юрии Гагарине и Владимире Комарове. Это стало доброй традицией: до 1989 года космонавты, возвратившиеся с орбиты на Землю, или их родственники в честь героев космоса высаживали на аллее каштаны — всего 76 деревьев.",
    "description_eng": "Cosmonauts' Alley was established by the planting of the first chestnut tree by cosmonaut Pavel Belyaev in memory of his fallen colleagues and friends Yuri Gagarin and Vladimir Komarov. This became a good tradition: until 1989, cosmonauts who returned from orbit to Earth or their relatives planted chestnut trees in honour of space heroes - 76 trees in total.",
    "width": "9.2",
    "height": "1",
    "left": "88.8",
    "top": "44.3",
    "borderRadius": "26",
    "transform": "30",
    "transformImage": "-30",
    "marginTop": "0",
    "marginRight": "1",
    "marginBot": "2",
    "marginLeft": "0",
    "media": {
      "width": "6.7",
      "height": "0.6",
      "left": "65.6",
      "top": "32.7",
      "borderRadius": "26",
      "transform": "30",
      "transformImage": "-30",
      "marginTop": "0",
      "marginRight": "1",
      "marginBot": "2",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Аллея Космонавтов (Каштановая роща).jpg`,
    "id": "temp19"
  },
  {
    "name": "Памятник В.И. Ленину",
    "name_eng": "Monument to V.I. Lenin",
    "description": "Этот скульптурный образ, созданный П.П. Яцыно, представляет собой образец советской монументальной пластики начала 1950-х годов — один из авторских вариантов-повторений.",
    "description_eng": "This sculptural image, created by P.P. Yatsyno, is an example of Soviet monumental plastic art of the early 1950s - one of the author's variants-repetitions.",
    "width": "3.1",
    "height": "2.6",
    "left": "81.5",
    "top": "42.3",
    "borderRadius": "36",
    "transform": "36",
    "transformImage": "-36",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "1",
    "marginLeft": "-1",
    "media": {
      "width": "2.1",
      "height": "1.6",
      "left": "60.1",
      "top": "31.3",
      "borderRadius": "38",
      "transform": "29",
      "transformImage": "-29",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "1",
      "marginLeft": "-1"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Памятник В.И. Ленину.jpg`,
    "id": "temp20"
  },
  {
    "name": "Северный розарий",
    "name_eng": "The northern rose garden",
    "description": "Цветочные композиции Северного розария сформированы из сортов, созданных специалистами разных стран, таких как Россия, Англия, Франция, Германия, Голландия, Америка, Ирландия, Канада.",
    "description_eng": "Flower compositions of the northern rose garden are formed from varieties created by specialists from different countries, such as Russia, England, France, Germany, Holland, America, Ireland, Canada.",
    "width": "8.4",
    "height": "1.4",
    "left": "81.8",
    "top": "39",
    "borderRadius": "26",
    "transform": "30",
    "transformImage": "-30",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "1",
    "marginLeft": "0",
    "media": {
      "width": "6.7",
      "height": "1.3",
      "left": "60",
      "top": "28.7",
      "borderRadius": "26",
      "transform": "30",
      "transformImage": "-30",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "1",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Северный розарий.jpg`,
    "id": "temp21"
  },
  {
    "name": "Южный розарий",
    "name_eng": "The southern rose garden",
    "description": "Южный розарий, спроектированный известными архитекторами Л. С. Залесской и Р. В. Обориной, располагается слева от Центральной аллеи. Розы поставлялись из Молдавии от известного производителя роз — совхоза \"Кодру\" АПО \"Виктория\".",
    "description_eng": "The southern rose garden, designed by renowned architects L. S. Zalesskaya and R. V. Oborina, is located to the left of the Central Alley. The roses were supplied from Moldova from a famous rose producer - the state farm \"Codru\" of the APO \"Victoria\".",
    "width": "",
    "height": "",
    "left": "",
    "top": "",
    "borderRadius": "100",
    "transform": "",
    "media": {
      "width": "",
      "height": "",
      "left": "",
      "top": "",
      "borderRadius": "100",
      "transform": ""
    },
    "hidden": true,
    "imgUrl": `${appConfig.staticDomain}/file/Южный Розарий.jpg`,
    "id": "temp22"
  },
  {
    "name": "Памятный знак \"Работникам ВСХВ, погибшим на фронтах Великой Отечественной войны 1941–1945 гг.\"",
    "name_eng": "Monument sign \"To the workers of the All-Union Agricultural Exhibition who died at the fronts of the Great Patriotic War of 1941-1945\".",
    "description": "Скульптурная композиция работы Кирилла Чижова выполнена в виде символичной стены, которая разделяет мирное и военное время. На одной части бронзового изваяния мы видим традиционную верхнюю одежду времен Отечественной войны — фуражку и куртку — и ручной инструмент для работы. На другой — рельефное изображение солдат у зенитной пушки на фоне павильона \"Рабочий и колхозница\". Площадка вокруг монумента вымощена гранитной брусчаткой: по ней можно подойти ближе к памятному знаку, чтобы лучше рассмотреть все детали и возложить цветы. Ландшафтное оформление завершает \"поле\" остроцветкового вейника, чьи строгие границы поддерживают геометрию всей композиции.",
    "description_eng": "The sculptural composition by Kirill Chizhov is made in the form of a symbolic wall that divides peacetime and wartime. On one part of the bronze sculpture we see traditional outer garments of the Patriotic War times - a cap and a jacket - and hand tools for work. On the other is a relief image of soldiers at an anti-aircraft gun against the background of the pavilion \"Rabochiy i kolhoznica\". The area around the monument is paved with granite paving stones: on it one can get closer to the memorial sign to have a better look at all the details and lay flowers. The landscape design is completed by a \"field\" of sharp-flowered reedgrass, whose strict borders support the geometry of the entire composition.",
    "width": "1",
    "height": "1",
    "left": "43.1",
    "top": "16.4",
    "borderRadius": "100",
    "transform": "",
    "marginTop": "0",
    "marginRight": "0",
    "marginBot": "2",
    "marginLeft": "0",
    "media": {
      "width": "0.6",
      "height": "1",
      "left": "31.8",
      "top": "12.1",
      "borderRadius": "100",
      "transform": "",
      "marginTop": "0",
      "marginRight": "0",
      "marginBot": "2",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/Памятный знак «Работникам ВСХВ, погибшим на фронтах Великой Отечественной войны 1941–1945 гг.».jpg`,
    "id": "temp23"
  },
  {
    "name": "Макет ракеты-носителя «Восток»",
    "name_eng": "Mett of a launch vehicle «Vostok»",
    "description": "Полюбуйтесь на макет ракеты, на которой Юрий Гагарин впервые совершил полет в космос.\n\nРакета-носитель «Восток» занимает особое место в истории отечественной космической программы, ведь именно этот аппарат 12 апреля 1961 года вывел на околоземную орбиту «Восток-1», на котором Юрий Гагарин совершил первый в истории Земли пилотируемый полет в космическое пространство.\n\nМакет ракеты-носителя «Восток» был установлен на ВДНХ 8 июля 1967 года — в честь 50-летия со дня Великой Октябрьской социалистической революции.",
    "description_eng": "In 1967, a full-size mock-up of the \"Vostok\" rocket, on which Yuri Gagarin flew into space on 12 April 1961, was installed above the pond on Industry Square. The Mi-8 is a Soviet multi-purpose helicopter developed by the Experimental Design Bureau (OKB) of M. L. Mil in the early 1960s. The Su-27 is a Soviet and Russian fourth-generation all-weather supersonic heavy fighter developed by the Sukhoi Design Bureau.",
    "mapIcon": "/mapElements/east.png",
    "class": "element11",
    "elementInfoClass": "element-info-11",
    "imgUrl": `${appConfig.staticDomain}/file/Площадь промышленности (Макет ракеты-носителя «Восток», Вертолет Ми-8, Су-27).jpg`,
    "id": "temp24"
  },
  {
    "name": "Детская площадка за павильоном №34",
    "name_eng": "Children's playground behind pavilion №34",
    "description": "Небольшая игровая зона для малышей расположена за павильоном №34 \"Космос\". Для удобства взрослых рядом с площадкой есть скамейки, где можно спокойно отдохнуть, наблюдая за ребенком.",
    "description_eng": "A small play area for toddlers is located behind Pavilion №34 \"Cosmos\". For the convenience of adults, there are benches near the playground where you can relax while watching your child.",
    "width": "2.4",
    "height": "1.9",
    "left": "19.2",
    "top": "12",
    "borderRadius": "65",
    "transform": "36",
    "transformImage": "-36",
    "marginTop": "0",
    "marginRight": "1",
    "marginBot": "2",
    "marginLeft": "0",
    "media": {
      "width": "1.7",
      "height": "1.2",
      "left": "14.2",
      "top": "8.6",
      "borderRadius": "65",
      "transform": "36",
      "transformImage": "-36",
      "marginTop": "0",
      "marginRight": "1",
      "marginBot": "2",
      "marginLeft": "0"
    },
    "imgUrl": `${appConfig.staticDomain}/file/детский сад.jpg`,
    "id": "temp25"
  },
  {
    "id": 7,
    "width": "",
    "height": "",
    "left": "",
    "top": "",
    "borderRadius": "100",
    "transform": "",
    "media": {
      "width": "",
      "height": "",
      "left": "",
      "top": "",
      "borderRadius": "100",
      "transform": ""
    },
    "hidden": true,
    "imgUrl": `${appConfig.staticDomain}/file/Главный вход.jpeg`,
    "name": "Северный розарий",
    "description": "Цветочные композиции Северного розария сформированы из сортов, созданных специалистами разных стран, таких как Россия, Англия, Франция, Германия, Голландия, Америка, Ирландия, Канада.\n\nРоссийская селекция представлена золотисто-оранжевой чайно-гибридной розой «Золотая осень».\n\nВ цветниках Северного розария высажены два немецких сорта — розово-абрикосовая «Geisha» и пурпурно-красная роза «Gospel» с густо махровыми цветами старомодной формы.\nФранцузская красная чайно-гибридная «Rose des 4 Vents» — двуцветная, бархатисто-красная с желтой изнанкой «Eddy Mitchel» и широко известная в мире желто-розовая «Gloria Dei».\n\nГолландская роза «Boeing» — одна из самых красивых белых роз среди чайно-гибридных сортов. Она отличается красивой формой бутона и крупным махровым цветком.\n\nКрупный яркий цветок американской чайно-гибридной розы «Chicago Peace» окрашен в карминовые, золотые и кораллово-розовые оттенки. Одиночные цветы сорта «Miranda Lambert» старинной формы имеют приятный аромат и насыщенный пурпурно-розовый цвет.\n\nЖелтая ирландская роза «Arthur Bell» отличается ярким фруктовым ароматом. Этот зимостойкий сорт заслуженно популярен в Англии и Северной Европе.\n\nКанадская роза «Therese Bugnet» замечательна не только из-за своей исключительной зимостойкости, но и благодаря крупным очень душистым розовым цветкам, которые появляются с раннего лета и до поздней осени."
  }
]